[
  {
    "id": "SLO1",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 47",
    "publisherGoalLabel": "Ruimtelijke inrichting",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren de ruimtelijke inrichting van de eigen omgeving te vergelijken met die in omgevingen elders, in binnen- en buitenland, vanuit de perspectieven landschap, wonen, werken, bestuur, verkeer, recreatie, welvaart, cultuur en levensbeschouwing. In ieder geval wordt daarbij aandacht besteed aan twee lidstaten van de Europese Unie en twee landen die in 2004 lid worden/ werden, de Verenigde Staten en een land in Azië, Afrika en Zuid-Amerika.",
    "domain": "Aardrijkskunde",
    "subDomain": null,
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO2",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 48",
    "publisherGoalLabel": "Omgang met water",
    "enduserLabel": null,
    "publisherGoalDescription": "Kinderen leren over de maatregelen die in Nederland genomen worden/ werden om bewoning van door water bedreigde gebieden mogelijk te maken.",
    "domain": "Aardrijkskunde",
    "subDomain": null,
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO3",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 49",
    "publisherGoalLabel": "Spreiding van bevolking en landschap",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren over de mondiale ruimtelijke spreiding van bevolkingsconcentraties en godsdiensten, van klimaten, energiebronnen en van natuurlandschappen zoals vulkanen, woestijnen, tropische regenwouden, hooggebergten en rivieren.",
    "domain": "Aardrijkskunde",
    "subDomain": null,
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO4",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 50",
    "publisherGoalLabel": "Kaart en atlas",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren omgaan met kaart en atlas, beheersen de basistopografie van Nederland, Europa en de rest van de wereld en ontwikkelen een eigentijds geografisch wereldbeeld.",
    "domain": "Aardrijkskunde",
    "subDomain": null,
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO5",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 57",
    "publisherGoalLabel": "Leren deelnemen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren op een verantwoorde manier deelnemen aan de omringende bewegingscultuur en leren de hoofdbeginselen van de belangrijkste bewegings- en spelvormen ervaren en uitvoeren.",
    "domain": "Bewegingsonderwijs",
    "subDomain": null,
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO6",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 58",
    "publisherGoalLabel": "Leren samenwerken",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren samen met anderen op een respectvolle manier aan bewegingsactiviteiten deelnemen, afspraken maken over het reguleren daarvan, de eigen bewegingsmogelijkheden inschatten en daarmee bij activiteiten rekening houden.",
    "domain": "Bewegingsonderwijs",
    "subDomain": null,
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO7",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 41",
    "publisherGoalLabel": "Bouw van organismen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren over de bouw van planten, dieren en mensen en over de vorm en functie van hun onderdelen.",
    "domain": "Biologie",
    "subDomain": null,
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO8",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 42",
    "publisherGoalLabel": "Natuurkundige verschijnselen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren onderzoek doen aan materialen en natuurkundige verschijnselen, zoals licht, geluid, electriciteit, kracht, magnetisme en temperatuur.",
    "domain": "Biologie",
    "subDomain": null,
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO9",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 44",
    "publisherGoalLabel": "Kennis van produkten",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren bij producten uit hun eigen omgeving relaties te leggen tussen de werking, de vorm en het materiaalgebruik.",
    "domain": "Biologie",
    "subDomain": null,
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO10",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 45",
    "publisherGoalLabel": "Technische oplossingen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren oplossingen voor technische problemen te ontwerpen, deze uit te voeren en te evalueren.",
    "domain": "Biologie",
    "subDomain": null,
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO11",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 46",
    "publisherGoalLabel": "Dagritme en seizoenen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren dat de positie van de aarde ten opzichte van de zon leidt tot natuurverschijnselen, zoals seizoenen en dag-/nachtritme.",
    "domain": "Biologie",
    "subDomain": null,
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO12",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 40",
    "publisherGoalLabel": "Planten en dieren herkennen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren in de eigen omgeving veel voorkomende planten en dieren onderscheiden en benoemen en leren hoe ze functioneren in hun leefomgeving.",
    "domain": "Biologie",
    "subDomain": null,
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO13",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 43",
    "publisherGoalLabel": "Weer en klimaat",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren hoe je weer en klimaat kunt beschrijven met behulp van temperatuur, neerslag en wind.",
    "domain": "Biologie",
    "subDomain": null,
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO14",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 13",
    "publisherGoalLabel": "Informatie verwerken",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren informatie te verwerven uit eenvoudige gesproken en geschreven Engelse teksten.",
    "domain": "Engels",
    "subDomain": null,
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO15",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 14",
    "publisherGoalLabel": "Spreken",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren in het Engels informatie te vragen of geven over eenvoudige onderwerpen en zij ontwikkelen een attitude waarbij ze zich durven uit te drukken in die taal.",
    "domain": "Engels",
    "subDomain": null,
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO16",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 15",
    "publisherGoalLabel": "Schrijfwijze van woorden",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren de schrijfwijze van enkele eenvoudige woorden over alledaagse onderwerpen.",
    "domain": "Engels",
    "subDomain": null,
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO17",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 16",
    "publisherGoalLabel": "Woordenboek hanteren",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren om woordbetekenissen en schrijfwijzen van Engelse woorden op te zoeken met behulp van het woordenboek.",
    "domain": "Engels",
    "subDomain": null,
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO18",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 20",
    "publisherGoalLabel": "Teksttypes hanteren",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren informatie te verwerven uit teksten in het Fries in frequent voorkomende teksttypen (zoals artikelen in jeugdrubrieken, liedjes, verhalen).",
    "domain": "Fries",
    "subDomain": "Schriftelijk taalonderwijs",
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO19",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 21",
    "publisherGoalLabel": "Teksten produceren",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren eenvoudige teksten in het Fries te schrijven over alledaagse onderwerpen met het doel met anderen over die onderwerpen te communiceren.",
    "domain": "Fries",
    "subDomain": "Schriftelijk taalonderwijs",
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO20",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 17",
    "publisherGoalLabel": "Positieve attitude",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen ontwikkelen een positieve attitude ten opzichte van het gebruik van Fries door henzelf en anderen.",
    "domain": "Fries",
    "subDomain": "Mondeling taalonderwijs",
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO21",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 18",
    "publisherGoalLabel": "Informatie verwerven",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren informatie te verwerven uit gesproken Fries. Het gaat om teksten die informatie geven, plezier verschaffen, meningen of aanwijzingen bevatten over voor hen bekende onderwerpen.",
    "domain": "Fries",
    "subDomain": "Mondeling taalonderwijs",
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO22",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 19",
    "publisherGoalLabel": "Spreken",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren zich naar inhoud en vorm in het Fries uit te drukken in situaties uit hun dagelijks leven waarin zij informatie vragen of geven over een onderwerp waarmee zij vertrouwd zijn.",
    "domain": "Fries",
    "subDomain": "Mondeling taalonderwijs",
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO23",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 22",
    "publisherGoalLabel": "Woordenschat",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen verwerven een woordenschat van frequent gebruikte Friese woorden en strategieën voor het begrijpen van voor hen onbekende woorden.",
    "domain": "Fries",
    "subDomain": "Taalbeschouwing, waaronder strategieën",
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO24",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 52",
    "publisherGoalLabel": "Tijdvakken",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren over kenmerkende aspecten van de volgende tijdvakken: jagers en boeren; Grieken en Romeinen; monniken en ridders; steden en staten; ontdekkers en hervormers; regenten en vorsten; pruiken en revoluties; burgers en stoommachines; wereldoorlogen en holocaust; televisie en computer. De vensters van de canon van Nederland dienen als uitgangspunt ter illustratie van de tijdvakken.",
    "domain": "Geschiedenis",
    "subDomain": null,
    "tags": [
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO25",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 53",
    "publisherGoalLabel": "Personen en gebeurtenissen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren over de belangrijke historische personen en gebeurtenissen uit de Nederlandse geschiedenis en kunnen die voorbeeldmatig verbinden met de wereldgeschiedenis.",
    "domain": "Geschiedenis",
    "subDomain": null,
    "tags": [
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO26",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 51",
    "publisherGoalLabel": "Historische bronnen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren gebruik te maken van eenvoudige historische bronnen, zoals aanwezig in ons cultureel erfgoed, en ze leren aanduidingen van tijd en tijdsindeling te hanteren.",
    "domain": "Geschiedenis",
    "subDomain": null,
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO27",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 54",
    "publisherGoalLabel": "Uitdrukken en communiceren",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren beelden, taal, muziek, spel en beweging te gebruiken om er gevoelens en ervaringen mee uit te drukken en om er mee te communiceren.",
    "domain": "Kunstzinnige oriëntatie",
    "subDomain": null,
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO28",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 55",
    "publisherGoalLabel": "Reflecteren",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren op eigen werk en dat van anderen te reflecteren.",
    "domain": "Kunstzinnige oriëntatie",
    "subDomain": null,
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO29",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 56",
    "publisherGoalLabel": "Cultureel erfgoed",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen verwerven enige kennis over en krijgen waardering voor aspecten van cultureel erfgoed.",
    "domain": "Kunstzinnige oriëntatie",
    "subDomain": null,
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO30",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 10",
    "publisherGoalLabel": "Strategieën hanteren",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren bij de doelen onder 'mondeling taalonderwijs' en 'schriftelijk taalonderwijs' strategieën te herkennen, te verwoorden, te gebruiken en te beoordelen.",
    "domain": "Nederlands",
    "subDomain": "Taalbeschouwing, waaronder strategieën",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO31",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 11",
    "publisherGoalLabel": "Principes en regels",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren een aantal taalkundige principes en regels. Zij kunnen in een zin het onderwerp, het werkwoordelijk gezegde en delen van dat gezegde onderscheiden. De leerlingen kennen: regels voor het spellen van werkwoorden;",
    "domain": "Nederlands",
    "subDomain": "Taalbeschouwing, waaronder strategieën",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO32",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 12",
    "publisherGoalLabel": "Woordenschat",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen verwerven een adequate woordenschat en strategieën voor het begrijpen van voor hen onbekende woorden. Onder 'woordenschat' vallen ook begrippen die het leerlingen mogelijk maken over taal te denken en te spreken.",
    "domain": "Nederlands",
    "subDomain": "Taalbeschouwing, waaronder strategieën",
    "tags": [
      "fase 1",
      "fase 2"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO33",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 01",
    "publisherGoalLabel": "Informatie verwerven",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren informatie te verwerven uit gesproken taal. Ze leren tevens die informatie, mondeling of schriftelijk, gestructureerd weer te geven.",
    "domain": "Nederlands",
    "subDomain": "Mondeling taalonderwijs",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO34",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 02",
    "publisherGoalLabel": "Spreken",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren zich naar vorm en inhoud uit te drukken bij het geven en vragen van informatie, het uitbrengen van verslag, het geven van uitleg, het instrueren en bij het discussiëren.",
    "domain": "Nederlands",
    "subDomain": "Mondeling taalonderwijs",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO35",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 03",
    "publisherGoalLabel": "Informatie beoordelen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren informatie te beoordelen in discussies en in een gesprek dat informatief of opiniërend van karakter is en leren met argumenten te reageren.",
    "domain": "Nederlands",
    "subDomain": "Mondeling taalonderwijs",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO36",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 04",
    "publisherGoalLabel": "Informatie opzoeken",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren informatie te achterhalen in informatieve en instructieve teksten, waaronder schema's, tabellen en digitale bronnen.",
    "domain": "Nederlands",
    "subDomain": "Schriftelijk taalonderwijs",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO37",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 05",
    "publisherGoalLabel": "Teksttypen onderscheiden",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren naar inhoud en vorm teksten te schrijven met verschillende functies, zoals: informeren, instrueren, overtuigen of plezier verschaffen.",
    "domain": "Nederlands",
    "subDomain": "Schriftelijk taalonderwijs",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO38",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 06",
    "publisherGoalLabel": "Informatie ordenen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren informatie en meningen te ordenen bij het lezen van school- en studieteksten en andere instructieve teksten, bij systematisch geordende bronnen, waaronder digitale.",
    "domain": "Nederlands",
    "subDomain": "Schriftelijk taalonderwijs",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO39",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 07",
    "publisherGoalLabel": "Informatie vergelijken",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren informatie en meningen te vergelijken en te beoordelen in verschillende teksten.",
    "domain": "Nederlands",
    "subDomain": "Schriftelijk taalonderwijs",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO40",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 08",
    "publisherGoalLabel": "Teksten produceren",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren informatie en meningen te ordenen bij het schrijven van een brief, een verslag, een formulier of een werkstuk. Zij besteden daarbij aandacht aan zinsbouw, correcte spelling, een leesbaar handschrift, bladspiegel, eventueel beeldende elementen en kleur.",
    "domain": "Nederlands",
    "subDomain": "Schriftelijk taalonderwijs",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO41",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 09",
    "publisherGoalLabel": "Plezier in lezen en schrijven",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen krijgen plezier in het lezen en schrijven van voor hen bestemde verhalen, gedichten en informatieve teksten.",
    "domain": "Nederlands",
    "subDomain": "Schriftelijk taalonderwijs",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO42",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 34",
    "publisherGoalLabel": "Gezondheid",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren zorg te dragen voor de lichamelijke en psychische gezondheid van henzelf en anderen.",
    "domain": "Oriëntatie op jezelf en de wereld",
    "subDomain": "Mens en samenleving",
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO43",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 35",
    "publisherGoalLabel": "Redzaam gedrag",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren zich redzaam te gedragen in sociaal opzicht, als verkeersdeelnemer en als consument.",
    "domain": "Oriëntatie op jezelf en de wereld",
    "subDomain": "Mens en samenleving",
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO44",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 36",
    "publisherGoalLabel": "Staatsinrichting",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren hoofdzaken van de Nederlandse en Europese staatsinrichting en hun rol als burger.",
    "domain": "Oriëntatie op jezelf en de wereld",
    "subDomain": "Mens en samenleving",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO45",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 37",
    "publisherGoalLabel": "Waarden en normen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren zich te gedragen vanuit respect voor algemeen aanvaarde waarden en normen.",
    "domain": "Oriëntatie op jezelf en de wereld",
    "subDomain": "Mens en samenleving",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO46",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 38",
    "publisherGoalLabel": "Geestelijke stromingen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren hoofdzaken over geestelijke stromingen die in de Nederlandse multiculturele samenleving een belangrijke rol spelen, en ze leren respectvol om te gaan met verschillen in opvattingen van mensen, en ze leren respectvol om te gaan met seksualiteit en met diversiteit binnen de samenleving, waaronder seksuele diversiteit.",
    "domain": "Oriëntatie op jezelf en de wereld",
    "subDomain": "Mens en samenleving",
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO47",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 39",
    "publisherGoalLabel": "Milieu",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren met zorg om te gaan met het milieu.",
    "domain": "Oriëntatie op jezelf en de wereld",
    "subDomain": "Mens en samenleving",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO48",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 41",
    "publisherGoalLabel": "Bouw van organismen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren over de bouw van planten, dieren en mensen en over de vorm en functie van hun onderdelen.",
    "domain": "Oriëntatie op jezelf en de wereld",
    "subDomain": "Natuur en techniek",
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO49",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 42",
    "publisherGoalLabel": "Natuurkundige verschijnselen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren onderzoek doen aan materialen en natuurkundige verschijnselen, zoals licht, geluid, electriciteit, kracht, magnetisme en temperatuur.",
    "domain": "Oriëntatie op jezelf en de wereld",
    "subDomain": "Natuur en techniek",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO50",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 44",
    "publisherGoalLabel": "Kennis van produkten",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren bij producten uit hun eigen omgeving relaties te leggen tussen de werking, de vorm en het materiaalgebruik.",
    "domain": "Oriëntatie op jezelf en de wereld",
    "subDomain": "Natuur en techniek",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO51",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 45",
    "publisherGoalLabel": "Technische oplossingen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren oplossingen voor technische problemen te ontwerpen, deze uit te voeren en te evalueren.",
    "domain": "Oriëntatie op jezelf en de wereld",
    "subDomain": "Natuur en techniek",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO52",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 46",
    "publisherGoalLabel": "Dagritme en seizoenen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren dat de positie van de aarde ten opzichte van de zon leidt tot natuurverschijnselen, zoals seizoenen en dag-/nachtritme.",
    "domain": "Oriëntatie op jezelf en de wereld",
    "subDomain": "Natuur en techniek",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO53",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 40",
    "publisherGoalLabel": "Planten en dieren herkennen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren in de eigen omgeving veel voorkomende planten en dieren onderscheiden en benoemen en leren hoe ze functioneren in hun leefomgeving.",
    "domain": "Oriëntatie op jezelf en de wereld",
    "subDomain": "Natuur en techniek",
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO54",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 43",
    "publisherGoalLabel": "Weer en klimaat",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren hoe je weer en klimaat kunt beschrijven met behulp van temperatuur, neerslag en wind.",
    "domain": "Oriëntatie op jezelf en de wereld",
    "subDomain": "Natuur en techniek",
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO55",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 47",
    "publisherGoalLabel": "Ruimtelijke inrichting",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren de ruimtelijke inrichting van de eigen omgeving te vergelijken met die in omgevingen elders, in binnen- en buitenland, vanuit de perspectieven landschap, wonen, werken, bestuur, verkeer, recreatie, welvaart, cultuur en levensbeschouwing. In ieder geval wordt daarbij aandacht besteed aan twee lidstaten van de Europese Unie en twee landen die in 2004 lid worden/ werden, de Verenigde Staten en een land in Azië, Afrika en Zuid-Amerika.",
    "domain": "Oriëntatie op jezelf en de wereld",
    "subDomain": "Ruimte",
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO56",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 48",
    "publisherGoalLabel": "Omgang met water",
    "enduserLabel": null,
    "publisherGoalDescription": "Kinderen leren over de maatregelen die in Nederland genomen worden/ werden om bewoning van door water bedreigde gebieden mogelijk te maken.",
    "domain": "Oriëntatie op jezelf en de wereld",
    "subDomain": "Ruimte",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO57",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 49",
    "publisherGoalLabel": "Spreiding van bevolking en landschap",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren over de mondiale ruimtelijke spreiding van bevolkingsconcentraties en godsdiensten, van klimaten, energiebronnen en van natuurlandschappen zoals vulkanen, woestijnen, tropische regenwouden, hooggebergten en rivieren.",
    "domain": "Oriëntatie op jezelf en de wereld",
    "subDomain": "Ruimte",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO58",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 50",
    "publisherGoalLabel": "Kaart en atlas",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren omgaan met kaart en atlas, beheersen de basistopografie van Nederland, Europa en de rest van de wereld en ontwikkelen een eigentijds geografisch wereldbeeld.",
    "domain": "Oriëntatie op jezelf en de wereld",
    "subDomain": "Ruimte",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO59",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 52",
    "publisherGoalLabel": "Tijdvakken",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren over kenmerkende aspecten van de volgende tijdvakken: jagers en boeren; Grieken en Romeinen; monniken en ridders; steden en staten; ontdekkers en hervormers; regenten en vorsten; pruiken en revoluties; burgers en stoommachines; wereldoorlogen en holocaust; televisie en computer. De vensters van de canon van Nederland dienen als uitgangspunt ter illustratie van de tijdvakken.",
    "domain": "Oriëntatie op jezelf en de wereld",
    "subDomain": "Tijd",
    "tags": [
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO60",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 53",
    "publisherGoalLabel": "Personen en gebeurtenissen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren over de belangrijke historische personen en gebeurtenissen uit de Nederlandse geschiedenis en kunnen die voorbeeldmatig verbinden met de wereldgeschiedenis.",
    "domain": "Oriëntatie op jezelf en de wereld",
    "subDomain": "Tijd",
    "tags": [
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO61",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 51",
    "publisherGoalLabel": "Historische bronnen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren gebruik te maken van eenvoudige historische bronnen, zoals aanwezig in ons cultureel erfgoed, en ze leren aanduidingen van tijd en tijdsindeling te hanteren.",
    "domain": "Oriëntatie op jezelf en de wereld",
    "subDomain": "Tijd",
    "tags": [],
    "maxValue": 3
  },
  {
    "id": "SLO62",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 23",
    "publisherGoalLabel": "Wiskundetaal gebruiken",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren wiskundetaal gebruiken.",
    "domain": "Rekenen en wiskunde",
    "subDomain": "Wiskundig inzicht en handelen",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO63",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 24",
    "publisherGoalLabel": "Wiskundige problemen oplossen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren praktische en formele reken-wiskundige problemen op te lossen en redeneringen helder weer te geven.",
    "domain": "Rekenen en wiskunde",
    "subDomain": "Wiskundig inzicht en handelen",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO64",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 25",
    "publisherGoalLabel": "Strategieen beoordelen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren aanpakken bij het oplossen van reken wiskundeproblemen te onderbouwen en leren oplossingen te beoordelen.",
    "domain": "Rekenen en wiskunde",
    "subDomain": "Wiskundig inzicht en handelen",
    "tags": [
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO65",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 26",
    "publisherGoalLabel": "Structuren doorzien",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren structuur en samenhang van aantallen, gehele getallen, kommagetallen, breuken, procenten en verhoudingen op hoofdlijnen te doorzien en er in praktische situaties mee te rekenen.",
    "domain": "Rekenen en wiskunde",
    "subDomain": "Getallen en bewerkingen",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO66",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 27",
    "publisherGoalLabel": "Basisbewerkingen automatiseren",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren de basisbewerkingen met gehele getallen in elk geval tot 100 snel uit het hoofd uitvoeren, waarbij optellen en aftrekken tot 20 en de tafels van buiten gekend zijn.",
    "domain": "Rekenen en wiskunde",
    "subDomain": "Getallen en bewerkingen",
    "tags": [
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO67",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 28",
    "publisherGoalLabel": "Schattend rekenen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren schattend tellen en rekenen.",
    "domain": "Rekenen en wiskunde",
    "subDomain": "Getallen en bewerkingen",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO68",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 29",
    "publisherGoalLabel": "Handig rekenen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren handig optellen, aftrekken, vermenigvuldigen en delen.",
    "domain": "Rekenen en wiskunde",
    "subDomain": "Getallen en bewerkingen",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO69",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 30",
    "publisherGoalLabel": "Standaardprocedures",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren schriftelijk optellen, aftrekken, vermenigvuldigen en delen volgens meer of minder verkorte standaardprocedures.",
    "domain": "Rekenen en wiskunde",
    "subDomain": "Getallen en bewerkingen",
    "tags": [
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO70",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 31",
    "publisherGoalLabel": "Rekenmachine",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren de rekenmachine met inzicht te gebruiken.",
    "domain": "Rekenen en wiskunde",
    "subDomain": "Getallen en bewerkingen",
    "tags": [
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO71",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 32",
    "publisherGoalLabel": "Meetkundige problemen oplossen",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren eenvoudige meetkundige problemen op te lossen.",
    "domain": "Rekenen en wiskunde",
    "subDomain": "Meten en meetkunde",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "SLO72",
    "schemaVersion": "1.0.0",
    "publisherName": "SLO",
    "publisherGoalId": "PO Kerndoel 33",
    "publisherGoalLabel": "Eenheden en maten",
    "enduserLabel": null,
    "publisherGoalDescription": "De leerlingen leren meten en leren te rekenen met eenheden en maten, zoals bij tijd, geld, lengte, omtrek, oppervlakte, inhoud, gewicht, snelheid en temperatuur.",
    "domain": "Rekenen en wiskunde",
    "subDomain": "Meten en meetkunde",
    "tags": [
      "fase 1",
      "fase 2",
      "fase 3"
    ],
    "maxValue": 3
  },
  {
    "id": "GA11",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-2",
    "publisherGoalLabel": "handelen",
    "enduserLabel": null,
    "publisherGoalDescription": "exploreert en doet ervaringen op met materiaal",
    "domain": "Spel",
    "subDomain": "Spel - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA12",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-3",
    "publisherGoalLabel": "rolgebruik",
    "enduserLabel": null,
    "publisherGoalDescription": "speelt naast een ander kind hetzelfde spel",
    "domain": "Spel",
    "subDomain": "Spel - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA13",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-4",
    "publisherGoalLabel": "speelduur",
    "enduserLabel": null,
    "publisherGoalDescription": "verkent korte tijd verschillende materialen",
    "domain": "Spel",
    "subDomain": "Spel - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA14",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-5",
    "publisherGoalLabel": "*speeltaal",
    "enduserLabel": null,
    "publisherGoalDescription": "gebruiken van speelgeluiden, eenvoudige taal",
    "domain": "Spel",
    "subDomain": "Spel - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA17",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-8",
    "publisherGoalLabel": "oriëntatie op verhaal en tekst",
    "enduserLabel": null,
    "publisherGoalDescription": "weet dat de boekomslag iets vertelt over het verhaal",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA18",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-9",
    "publisherGoalLabel": "taalbewustzijn",
    "enduserLabel": null,
    "publisherGoalDescription": "onthoudt een rijmpje/versje en zegt het op",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA19",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-10",
    "publisherGoalLabel": "oriëntatie op geschreven taal",
    "enduserLabel": null,
    "publisherGoalDescription": "toont interesse in boeken en verhalen",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA110",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-11",
    "publisherGoalLabel": "*taalbewustzijn",
    "enduserLabel": null,
    "publisherGoalDescription": "ervaringen opdoen met rijmen",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA111",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-12",
    "publisherGoalLabel": "*oriëntatie op geschreven taal",
    "enduserLabel": null,
    "publisherGoalDescription": "spelen met lettermateriaal (bijv. stempels, magneetletters)",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA112",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-13",
    "publisherGoalLabel": "*visuele waarneming",
    "enduserLabel": null,
    "publisherGoalDescription": "verschillen zien tussen concrete voorwerpen op een afbeelding",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA113",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-14",
    "publisherGoalLabel": "*leesplezier",
    "enduserLabel": null,
    "publisherGoalDescription": "genieten van voorgelezen versjes en verhaaltjes",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA116",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-17",
    "publisherGoalLabel": "luisteren",
    "enduserLabel": null,
    "publisherGoalDescription": "luistert naar en begrijpt een enkelvoudige instructie",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA117",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-18",
    "publisherGoalLabel": "spreken",
    "enduserLabel": null,
    "publisherGoalDescription": "spreekt in zinnen van vier woorden",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA118",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-19",
    "publisherGoalLabel": "gesprekken",
    "enduserLabel": null,
    "publisherGoalDescription": "voert een gesprekje met de leerkracht en/of een ander kind",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA119",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-20",
    "publisherGoalLabel": "*woordenschat",
    "enduserLabel": null,
    "publisherGoalDescription": "uitbreiden van passieve en actieve woordenschat",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA122",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-23",
    "publisherGoalLabel": "telrij",
    "enduserLabel": null,
    "publisherGoalDescription": "zegt de telrij tot 5 op",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA123",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-24",
    "publisherGoalLabel": "hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "vergelijkt hoeveelheden op veel en weinig",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA124",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-25",
    "publisherGoalLabel": "*hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "eerlijk verdelen van voorwerpen over verschillende bakjes",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA127",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-28",
    "publisherGoalLabel": "lengte en omtrek",
    "enduserLabel": null,
    "publisherGoalDescription": "kan de begrippen kort/lang en laag/hoog aanwijzen",
    "domain": "Meten",
    "subDomain": "Meten - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA128",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-29",
    "publisherGoalLabel": "tijd",
    "enduserLabel": null,
    "publisherGoalDescription": "begrijpt woorden als snel, nu, vroeg en laat",
    "domain": "Meten",
    "subDomain": "Meten - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA129",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-30",
    "publisherGoalLabel": "*lengte en omtrek",
    "enduserLabel": null,
    "publisherGoalDescription": "oefenen met de begrippen dik en dun",
    "domain": "Meten",
    "subDomain": "Meten - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA132",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-33",
    "publisherGoalLabel": "oriënteren in de ruimte",
    "enduserLabel": null,
    "publisherGoalDescription": "weet waar iets zich bevindt ten opzichte van het eigen lichaam (bijv. voor, achter, naast, in, op, onder)",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA133",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-34",
    "publisherGoalLabel": "construeren",
    "enduserLabel": null,
    "publisherGoalDescription": "kan blokken stapelen en ruimtelijk bouwen",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA134",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-35",
    "publisherGoalLabel": "opereren met vormen en figuren",
    "enduserLabel": null,
    "publisherGoalDescription": "kan de kleuren rood, blauw, groen en geel aanwijzen",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA137",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-38",
    "publisherGoalLabel": "klimmen",
    "enduserLabel": null,
    "publisherGoalDescription": "klimt in een klimtoestel omhoog en omlaag",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA138",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-39",
    "publisherGoalLabel": "balanceren",
    "enduserLabel": null,
    "publisherGoalDescription": "loopt over een recht en breed balanceervlak (bank) met hulp",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA139",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-40",
    "publisherGoalLabel": "hinkelen",
    "enduserLabel": null,
    "publisherGoalDescription": "staat kort op één been",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA140",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-41",
    "publisherGoalLabel": "vrij springen",
    "enduserLabel": null,
    "publisherGoalDescription": "springt van een kleine hoogte af, met beide voeten tegelijk",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA141",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-42",
    "publisherGoalLabel": "mikken",
    "enduserLabel": null,
    "publisherGoalDescription": "gooit een bal zonder zijn evenwicht te verliezen",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA145",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-46",
    "publisherGoalLabel": "Maakt grove bewegingen vanuit schouder (bijv. verven of tekenen op groot papier)  ",
    "enduserLabel": null,
    "publisherGoalDescription": "Maakt grove bewegingen vanuit schouder (bijv. verven of tekenen op groot papier)  ",
    "domain": "Motoriek",
    "subDomain": "Fijne motoriek - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA146",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-47",
    "publisherGoalLabel": "Kan bewegingen maken met handen en vingers (bijv. grote kralen rijgen)",
    "enduserLabel": null,
    "publisherGoalDescription": "Kan bewegingen maken met handen en vingers (bijv. grote kralen rijgen)",
    "domain": "Motoriek",
    "subDomain": "Fijne motoriek - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA149",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-50",
    "publisherGoalLabel": "Komt ontspannen over",
    "enduserLabel": null,
    "publisherGoalDescription": "Komt ontspannen over",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA150",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-51",
    "publisherGoalLabel": "Heeft plezier in wat het doet",
    "enduserLabel": null,
    "publisherGoalDescription": "Heeft plezier in wat het doet",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA151",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-52",
    "publisherGoalLabel": "Laat zelfvertrouwen zien",
    "enduserLabel": null,
    "publisherGoalDescription": "Laat zelfvertrouwen zien",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA152",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-53",
    "publisherGoalLabel": "Durft zichzelf te zijn in de groep",
    "enduserLabel": null,
    "publisherGoalDescription": "Durft zichzelf te zijn in de groep",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA154",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-55",
    "publisherGoalLabel": "Toont belangstelling voor activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Toont belangstelling voor activiteiten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA155",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-56",
    "publisherGoalLabel": "Laat concentratie zien bij activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Laat concentratie zien bij activiteiten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA156",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-57",
    "publisherGoalLabel": "Kan opgaan in activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Kan opgaan in activiteiten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA157",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-58",
    "publisherGoalLabel": "Zet door bij activiteiten, ook als het tegenzit",
    "enduserLabel": null,
    "publisherGoalDescription": "Zet door bij activiteiten, ook als het tegenzit",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA160",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-61",
    "publisherGoalLabel": "gevoelens",
    "enduserLabel": null,
    "publisherGoalDescription": "uit emotie in situaties",
    "domain": "Besef van zichzelf",
    "subDomain": "Besef van zichzelf - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA161",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-62",
    "publisherGoalLabel": "persoonskenmerken",
    "enduserLabel": null,
    "publisherGoalDescription": "benoemt (lichaams)kenmerken van zichzelf",
    "domain": "Besef van zichzelf",
    "subDomain": "Besef van zichzelf - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA164",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-65",
    "publisherGoalLabel": "gevoelens hanteren",
    "enduserLabel": null,
    "publisherGoalDescription": "reageert (non-)verbaal op verschillende situaties",
    "domain": "Omgaan met zichzelf",
    "subDomain": "Omgaan met zichzelf - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA165",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-66",
    "publisherGoalLabel": "impulscontrole",
    "enduserLabel": null,
    "publisherGoalDescription": "kan behoeftes tijdelijk uitstellen",
    "domain": "Omgaan met zichzelf",
    "subDomain": "Omgaan met zichzelf - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA168",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-69",
    "publisherGoalLabel": "gevoelens",
    "enduserLabel": null,
    "publisherGoalDescription": "ziet emoties van een ander",
    "domain": "Besef van de ander",
    "subDomain": "Besef van de ander - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA169",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-70",
    "publisherGoalLabel": "persoonskenmerken",
    "enduserLabel": null,
    "publisherGoalDescription": "herkent verschillen tussen zichzelf en de ander",
    "domain": "Besef van de ander",
    "subDomain": "Besef van de ander - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA172",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-73",
    "publisherGoalLabel": "aansluiten",
    "enduserLabel": null,
    "publisherGoalDescription": "toont interesse in de ander",
    "domain": "Omgaan met de ander",
    "subDomain": "Omgaan met de ander - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA173",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-74",
    "publisherGoalLabel": "conflicten",
    "enduserLabel": null,
    "publisherGoalDescription": "verkent wat eigen grenzen zijn",
    "domain": "Omgaan met de ander",
    "subDomain": "Omgaan met de ander - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA174",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-75",
    "publisherGoalLabel": "samenwerken",
    "enduserLabel": null,
    "publisherGoalDescription": "beseft dat anderen naast hem/haar spelen",
    "domain": "Omgaan met de ander",
    "subDomain": "Omgaan met de ander - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA177",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-78",
    "publisherGoalLabel": "weloverwogen kiezen",
    "enduserLabel": null,
    "publisherGoalDescription": "kiest tussen twee mogelijkheden",
    "domain": "Keuzes maken",
    "subDomain": "Keuzes maken - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA178",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "0-doelen-79",
    "publisherGoalLabel": "zelfstandigheid",
    "enduserLabel": null,
    "publisherGoalDescription": "voert een eenvoudige taak zelf uit",
    "domain": "Keuzes maken",
    "subDomain": "Keuzes maken - 0",
    "tags": [
      "",
      "0-doelen",
      "-19--19"
    ],
    "maxValue": 1
  },
  {
    "id": "GA21",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-2",
    "publisherGoalLabel": "handelen",
    "enduserLabel": null,
    "publisherGoalDescription": "laat symbolisch spel zien (materiaal wordt anders gebruikt)",
    "domain": "Spel",
    "subDomain": "Spel - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA22",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-3",
    "publisherGoalLabel": "rolgebruik",
    "enduserLabel": null,
    "publisherGoalDescription": "handelt eerst en koppelt daarna een rol aan het spel",
    "domain": "Spel",
    "subDomain": "Spel - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA23",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-4",
    "publisherGoalLabel": "rolgebruik",
    "enduserLabel": null,
    "publisherGoalDescription": "laat aanzet tot samenspelen zien",
    "domain": "Spel",
    "subDomain": "Spel - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA24",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-5",
    "publisherGoalLabel": "spelverhaal",
    "enduserLabel": null,
    "publisherGoalDescription": "speelt een aantal beperkte handelingen in het rollenspel",
    "domain": "Spel",
    "subDomain": "Spel - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA25",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-6",
    "publisherGoalLabel": "speelduur",
    "enduserLabel": null,
    "publisherGoalDescription": "speelt een spelscenario van ± 5-10 minuten (in een rol)",
    "domain": "Spel",
    "subDomain": "Spel - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA26",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-7",
    "publisherGoalLabel": "*speeltaal",
    "enduserLabel": null,
    "publisherGoalDescription": "verwoorden van de handelingen",
    "domain": "Spel",
    "subDomain": "Spel - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA29",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-10",
    "publisherGoalLabel": "oriëntatie op verhaal en tekst",
    "enduserLabel": null,
    "publisherGoalDescription": "kan iets navertellen aan de hand van een plaat uit een boek",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA210",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-11",
    "publisherGoalLabel": "taalbewustzijn",
    "enduserLabel": null,
    "publisherGoalDescription": "herkent het woordbeeld van zijn naam",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA211",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-12",
    "publisherGoalLabel": "oriëntatie op geschreven taal",
    "enduserLabel": null,
    "publisherGoalDescription": "doet alsof het leest",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA212",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-13",
    "publisherGoalLabel": "visuele waarneming",
    "enduserLabel": null,
    "publisherGoalDescription": "kan het verschil zien tussen concrete voorwerpen op een afbeelding",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA213",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-14",
    "publisherGoalLabel": "*taalbewustzijn",
    "enduserLabel": null,
    "publisherGoalDescription": "spelen met woorden en letters, zoals woordspelletjes, rijmen",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA214",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-15",
    "publisherGoalLabel": "*oriëntatie op geschreven taal",
    "enduserLabel": null,
    "publisherGoalDescription": "spelend woorden maken met lettermateriaal",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA216",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-17",
    "publisherGoalLabel": "*leesplezier",
    "enduserLabel": null,
    "publisherGoalDescription": "meeleven met personages in het voorgelezen verhaal",
    "domain": "*VISUELE WAARNEMING: meerdere details aanwijzen op een illustratie n.a.v. vragen",
    "subDomain": "Geletterdheid - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA219",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-20",
    "publisherGoalLabel": "luisteren",
    "enduserLabel": null,
    "publisherGoalDescription": "luistert naar en begrijpt een meervoudige instructie",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA220",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-21",
    "publisherGoalLabel": "spreken",
    "enduserLabel": null,
    "publisherGoalDescription": "spreekt in langere zinnen van ongeveer zes tot acht woorden",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA221",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-22",
    "publisherGoalLabel": "gesprekken",
    "enduserLabel": null,
    "publisherGoalDescription": "geeft antwoord op een vraag van de leerkracht of een ander kind",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA222",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-23",
    "publisherGoalLabel": "*woordenschat",
    "enduserLabel": null,
    "publisherGoalDescription": "leren en gebruiken van (nieuwe) woorden naar aanleiding van verhalen en/of een thema; woorden liggen dicht bij het kind",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA225",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-26",
    "publisherGoalLabel": "telrij",
    "enduserLabel": null,
    "publisherGoalDescription": "zegt de telrij tot 10 op",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA226",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-27",
    "publisherGoalLabel": "hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "telt voorwerpen tot en met 5; synchroon",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA227",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-28",
    "publisherGoalLabel": "hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "vergelijkt hoeveelheden op meer en minder",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA228",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-29",
    "publisherGoalLabel": "*hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "voorwerp erbij of eraf doen en beseffen dat het er één meer of minder wordt",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA229",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-30",
    "publisherGoalLabel": "*hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "schatten van hoeveelheden tot 6",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA230",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-31",
    "publisherGoalLabel": "*hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "ontdekken dat hoeveelheden verschoven of bedekt kunnen worden zonder dat het aantal verandert",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA233",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-34",
    "publisherGoalLabel": "lengte en omtrek",
    "enduserLabel": null,
    "publisherGoalDescription": "kan de begrippen kort/lang en laag/hoog benoemen",
    "domain": "Meten",
    "subDomain": "Meten - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA234",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-35",
    "publisherGoalLabel": "tijd",
    "enduserLabel": null,
    "publisherGoalDescription": "kent de begrippen ochtend, middag, avond en nacht",
    "domain": "Meten",
    "subDomain": "Meten - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA235",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-36",
    "publisherGoalLabel": "*oppervlakte",
    "enduserLabel": null,
    "publisherGoalDescription": "aanwijzen van de grootste en de kleinste",
    "domain": "Meten",
    "subDomain": "Meten - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA236",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-37",
    "publisherGoalLabel": "*tijd",
    "enduserLabel": null,
    "publisherGoalDescription": "oefenen met de begrippen gisteren, morgen en overmorgen",
    "domain": "Meten",
    "subDomain": "Meten - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA237",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-38",
    "publisherGoalLabel": "*gewicht",
    "enduserLabel": null,
    "publisherGoalDescription": "oefenen met de begrippen zwaar en licht",
    "domain": "Meten",
    "subDomain": "Meten - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA238",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-39",
    "publisherGoalLabel": "*inhoud",
    "enduserLabel": null,
    "publisherGoalDescription": "oefenen met de begrippen vol en leeg",
    "domain": "Meten",
    "subDomain": "Meten - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA241",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-42",
    "publisherGoalLabel": "oriënteren in de ruimte",
    "enduserLabel": null,
    "publisherGoalDescription": "hanteert meetkundige begrippen als voor, achter, op, in en naast, in relatie tot eigen lichaam",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA242",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-43",
    "publisherGoalLabel": "construeren",
    "enduserLabel": null,
    "publisherGoalDescription": "kan een patroon van twee voorwerpen voortzetten (bijv. ketting, mozaïek, vormen)",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA243",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-44",
    "publisherGoalLabel": "opereren met vormen en figuren",
    "enduserLabel": null,
    "publisherGoalDescription": "benoemt de primaire kleuren",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA244",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-45",
    "publisherGoalLabel": "opereren met vormen en figuren",
    "enduserLabel": null,
    "publisherGoalDescription": "benoemt de vormen cirkel, driehoek en vierkant",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA245",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-46",
    "publisherGoalLabel": "*construeren",
    "enduserLabel": null,
    "publisherGoalDescription": "knutselen met papier",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA246",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-47",
    "publisherGoalLabel": "*construeren",
    "enduserLabel": null,
    "publisherGoalDescription": "vouwen van een schuine vouw",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA247",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-48",
    "publisherGoalLabel": "*construeren",
    "enduserLabel": null,
    "publisherGoalDescription": "betekenis geven aan gemaakte bouwwerken (bijv. huis of boot)",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA248",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-49",
    "publisherGoalLabel": "*opereren met vormen en figuren",
    "enduserLabel": null,
    "publisherGoalDescription": "sorteren op 1 kenmerk (bijv. cirkels en vierkanten)",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 1a",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA252",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-53",
    "publisherGoalLabel": "Komt ontspannen over",
    "enduserLabel": null,
    "publisherGoalDescription": "Komt ontspannen over",
    "domain": "Welbevinden, betrokkenheid/taakgerichtheid",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA253",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-54",
    "publisherGoalLabel": "Heeft plezier in wat het doet",
    "enduserLabel": null,
    "publisherGoalDescription": "Heeft plezier in wat het doet",
    "domain": "Welbevinden, betrokkenheid/taakgerichtheid",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA254",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-55",
    "publisherGoalLabel": "Laat zelfvertrouwen zien",
    "enduserLabel": null,
    "publisherGoalDescription": "Laat zelfvertrouwen zien",
    "domain": "Welbevinden, betrokkenheid/taakgerichtheid",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA255",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-56",
    "publisherGoalLabel": "Durft zichzelf te zijn in de groep",
    "enduserLabel": null,
    "publisherGoalDescription": "Durft zichzelf te zijn in de groep",
    "domain": "Welbevinden, betrokkenheid/taakgerichtheid",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA258",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-59",
    "publisherGoalLabel": "Toont belangstelling voor activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Toont belangstelling voor activiteiten",
    "domain": "Welbevinden, betrokkenheid/taakgerichtheid",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA259",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-60",
    "publisherGoalLabel": "Laat concentratie zien bij activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Laat concentratie zien bij activiteiten",
    "domain": "Welbevinden, betrokkenheid/taakgerichtheid",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA260",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-61",
    "publisherGoalLabel": "Kan opgaan in activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Kan opgaan in activiteiten",
    "domain": "Welbevinden, betrokkenheid/taakgerichtheid",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA261",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1a-doelen-62",
    "publisherGoalLabel": "Zet door bij activiteiten, ook als het tegenzit",
    "enduserLabel": null,
    "publisherGoalDescription": "Zet door bij activiteiten, ook als het tegenzit",
    "domain": "Welbevinden, betrokkenheid/taakgerichtheid",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "1a-doelen",
      "-19--15"
    ],
    "maxValue": 1
  },
  {
    "id": "GA31",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-2",
    "publisherGoalLabel": "handelen",
    "enduserLabel": null,
    "publisherGoalDescription": "plant rollen en handelingen vooraf en tijdens het spel",
    "domain": "Spel",
    "subDomain": "Spel - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA32",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-3",
    "publisherGoalLabel": "rolgebruik",
    "enduserLabel": null,
    "publisherGoalDescription": "speelt rollen samen met een ander kind binnen de regels",
    "domain": "Spel",
    "subDomain": "Spel - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA33",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-4",
    "publisherGoalLabel": "spelverhaal",
    "enduserLabel": null,
    "publisherGoalDescription": "speelt eenvoudige spelscenario's die passen bij een rol",
    "domain": "Spel",
    "subDomain": "Spel - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA34",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-5",
    "publisherGoalLabel": "speelduur",
    "enduserLabel": null,
    "publisherGoalDescription": "speelt een spelscenario van ± 10 minuten (in een rol)",
    "domain": "Spel",
    "subDomain": "Spel - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA35",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-6",
    "publisherGoalLabel": "*speeltaal",
    "enduserLabel": null,
    "publisherGoalDescription": "beschrijven van rolgebonden handelingen tijdens/na het spel",
    "domain": "Spel",
    "subDomain": "Spel - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA38",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-9",
    "publisherGoalLabel": "oriëntatie op verhaal en tekst",
    "enduserLabel": null,
    "publisherGoalDescription": "vertelt een verhaal na met behulp van platen",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA39",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-10",
    "publisherGoalLabel": "taalbewustzijn",
    "enduserLabel": null,
    "publisherGoalDescription": "onderscheidt een woord in een reeks van woorden",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA310",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-11",
    "publisherGoalLabel": "oriëntatie op geschreven taal",
    "enduserLabel": null,
    "publisherGoalDescription": "geeft zijn eigen naam of woorden weer door te schrijven (tekenen)",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA311",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-12",
    "publisherGoalLabel": "visuele waarneming",
    "enduserLabel": null,
    "publisherGoalDescription": "kan meerdere details op een plaat aanwijzen n.a.v. vragen",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA312",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-13",
    "publisherGoalLabel": "*oriëntatie op verhaal en tekst",
    "enduserLabel": null,
    "publisherGoalDescription": "kennismaken met wat de hoofdcomponenten zijn in het verhaal (n.a.v. 'wie-' en 'wat-' vragen, evt. m.b.v. picto's)",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA313",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-14",
    "publisherGoalLabel": "*taalbewustzijn",
    "enduserLabel": null,
    "publisherGoalDescription": "spelenderwijs bezig zijn met klanken, zoals rijmwoorden",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA314",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-15",
    "publisherGoalLabel": "*taalbewustzijn",
    "enduserLabel": null,
    "publisherGoalDescription": "spelenderwijs fonemen en klankeenheden (bijv. beginklank) van themawoorden of namen herkennen",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA315",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-16",
    "publisherGoalLabel": "*leesplezier",
    "enduserLabel": null,
    "publisherGoalDescription": "beleven van verschillende emoties of gevoelens van personages in het voorgelezen verhaal",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA318",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-19",
    "publisherGoalLabel": "luisteren",
    "enduserLabel": null,
    "publisherGoalDescription": "interpreteert wat er wordt verteld (vanuit eigen kennis en ervaring)",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA319",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-20",
    "publisherGoalLabel": "spreken",
    "enduserLabel": null,
    "publisherGoalDescription": "vertelt in enkele eenvoudig samengestelde zinnen een verhaal of gebeurtenis",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA320",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-21",
    "publisherGoalLabel": "gesprekken",
    "enduserLabel": null,
    "publisherGoalDescription": "houdt zich aan gespreksregels, zoals de ander aankijken en stil zijn",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA321",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-22",
    "publisherGoalLabel": "*woordenschat",
    "enduserLabel": null,
    "publisherGoalDescription": "leren en gebruiken van (nieuwe) woorden passend in een netwerk van woorden",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA324",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-25",
    "publisherGoalLabel": "telrij",
    "enduserLabel": null,
    "publisherGoalDescription": "zegt de telrij tot 20 op",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA325",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-26",
    "publisherGoalLabel": "hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "telt voorwerpen tot en met 10; synchroon en resultatief",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA326",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-27",
    "publisherGoalLabel": "getallen",
    "enduserLabel": null,
    "publisherGoalDescription": "kan de getalsymbolen 0 t/m 5 lezen",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA327",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-28",
    "publisherGoalLabel": "*telrij",
    "enduserLabel": null,
    "publisherGoalDescription": "terugtellen vanaf 10",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA328",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-29",
    "publisherGoalLabel": "*hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "vergelijken van hoeveelheden tot tenminste 5 (bijv. door het leggen van 1-1 relatie) op meeste, minste (meer, minder) en evenveel",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA329",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-30",
    "publisherGoalLabel": "*hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "schatten van hoeveelheden tot 10",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA330",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-31",
    "publisherGoalLabel": "*hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "handig organiseren van het tellen van hoeveelheden door te structureren",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 1b",
    "tags": [
      " op een rijtje leggen, groeperen",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA331",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-32",
    "publisherGoalLabel": "*hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "rekenproblemen begrijpen vanuit een context (bijv. prentenboek)",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA332",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-33",
    "publisherGoalLabel": "*getallen",
    "enduserLabel": null,
    "publisherGoalDescription": "oefenen met de vaste volgorde van getallen in de getallenrij tot 10",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA335",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-36",
    "publisherGoalLabel": "lengte en omtrek",
    "enduserLabel": null,
    "publisherGoalDescription": "kan tegenstellingen benoemen",
    "domain": "Meten",
    "subDomain": "Meten - 1b",
    "tags": [
      " kortste/langste, laagste/hoogste",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA336",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-37",
    "publisherGoalLabel": "oppervlakte",
    "enduserLabel": null,
    "publisherGoalDescription": "kan tegenstellingen benoemen",
    "domain": "Meten",
    "subDomain": "Meten - 1b",
    "tags": [
      " grootste/kleinste",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA337",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-38",
    "publisherGoalLabel": "tijd",
    "enduserLabel": null,
    "publisherGoalDescription": "benoemt de namen van de dagen van de week in de goede volgorde",
    "domain": "Meten",
    "subDomain": "Meten - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA338",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-39",
    "publisherGoalLabel": "*tijd",
    "enduserLabel": null,
    "publisherGoalDescription": "ervaren dat de tijd verstrijkt (bijv. zandloper, klok, time timer, kookwekker, kalender)",
    "domain": "Meten",
    "subDomain": "Meten - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA339",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-40",
    "publisherGoalLabel": "*geld",
    "enduserLabel": null,
    "publisherGoalDescription": "oefenen met tegenstellingen",
    "domain": "Meten",
    "subDomain": "Meten - 1b",
    "tags": [
      " duurste/goedkoopste",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA340",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-41",
    "publisherGoalLabel": "*gewicht",
    "enduserLabel": null,
    "publisherGoalDescription": "oefenen met tegenstellingen",
    "domain": "Meten",
    "subDomain": "Meten - 1b",
    "tags": [
      " lichtste/zwaarste",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA341",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-42",
    "publisherGoalLabel": "*inhoud",
    "enduserLabel": null,
    "publisherGoalDescription": "ordenen van inhoud en begrippen benoemen",
    "domain": "Meten",
    "subDomain": "Meten - 1b",
    "tags": [
      " van leeg naar vol, minder-meer-evenveel",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA344",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-45",
    "publisherGoalLabel": "oriënteren in de ruimte",
    "enduserLabel": null,
    "publisherGoalDescription": "hanteert meetkundige begrippen als voor, achter, naast, in, op, boven en onder",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA345",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-46",
    "publisherGoalLabel": "construeren",
    "enduserLabel": null,
    "publisherGoalDescription": "bouwt een eenvoudige foto of voorbeeld na in de ruimte",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA346",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-47",
    "publisherGoalLabel": "opereren met vormen en figuren",
    "enduserLabel": null,
    "publisherGoalDescription": "sorteert voorwerpen op minimaal twee kenmerken (bijv. rode rondjes, groene vierkanten)",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA347",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-48",
    "publisherGoalLabel": "*oriënteren in de ruimte",
    "enduserLabel": null,
    "publisherGoalDescription": "lopen van een eenvoudige route",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA348",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-49",
    "publisherGoalLabel": "*construeren",
    "enduserLabel": null,
    "publisherGoalDescription": "vouwen van een recht kruis",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA349",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-50",
    "publisherGoalLabel": "*construeren",
    "enduserLabel": null,
    "publisherGoalDescription": "maken van mozaïek en kettingpatronen",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA350",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-51",
    "publisherGoalLabel": "*opereren met vormen en figuren",
    "enduserLabel": null,
    "publisherGoalDescription": "spelen met licht en schaduw van zon of zaklamp",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 1b",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA353",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-54",
    "publisherGoalLabel": "Komt ontspannen over",
    "enduserLabel": null,
    "publisherGoalDescription": "Komt ontspannen over",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA354",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-55",
    "publisherGoalLabel": "Heeft plezier in wat het doet",
    "enduserLabel": null,
    "publisherGoalDescription": "Heeft plezier in wat het doet",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA355",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-56",
    "publisherGoalLabel": "Laat zelfvertrouwen zien",
    "enduserLabel": null,
    "publisherGoalDescription": "Laat zelfvertrouwen zien",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA356",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-57",
    "publisherGoalLabel": "Durft zichzelf te zijn in de groep",
    "enduserLabel": null,
    "publisherGoalDescription": "Durft zichzelf te zijn in de groep",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA358",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-59",
    "publisherGoalLabel": "Toont belangstelling voor activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Toont belangstelling voor activiteiten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA359",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-60",
    "publisherGoalLabel": "Laat concentratie zien bij activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Laat concentratie zien bij activiteiten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA360",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-61",
    "publisherGoalLabel": "Kan opgaan in activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Kan opgaan in activiteiten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA361",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1b-doelen-62",
    "publisherGoalLabel": "Zet door bij activiteiten, ook als het tegenzit",
    "enduserLabel": null,
    "publisherGoalDescription": "Zet door bij activiteiten, ook als het tegenzit",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "1b-doelen",
      "-14--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA42",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-3",
    "publisherGoalLabel": "klimmen",
    "enduserLabel": null,
    "publisherGoalDescription": "klimt in een klauterrek op verschillende hoogte heen en weer",
    "domain": "Grove motoriek",
    "subDomain": "Grove motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA43",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-4",
    "publisherGoalLabel": "huppelen",
    "enduserLabel": null,
    "publisherGoalDescription": "galoppeert",
    "domain": "Grove motoriek",
    "subDomain": "Grove motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA44",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-5",
    "publisherGoalLabel": "balanceren",
    "enduserLabel": null,
    "publisherGoalDescription": "balanceert over een recht en breed balanceervlak (bank) zonder hulp",
    "domain": "Grove motoriek",
    "subDomain": "Grove motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA45",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-6",
    "publisherGoalLabel": "balanceren",
    "enduserLabel": null,
    "publisherGoalDescription": "balanceert met hindernissen over een recht en breed balanceervlak (bank) zonder hulp",
    "domain": "Grove motoriek",
    "subDomain": "Grove motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA46",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-7",
    "publisherGoalLabel": "hinkelen",
    "enduserLabel": null,
    "publisherGoalDescription": "hinkelt 5 keer op voorkeursbeen",
    "domain": "Grove motoriek",
    "subDomain": "Grove motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA47",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-8",
    "publisherGoalLabel": "vrij springen",
    "enduserLabel": null,
    "publisherGoalDescription": "springt vanuit stilstand met 2 benen tegelijk vanaf een hoogte en komt met 2 benen tegelijk op de grond",
    "domain": "Grove motoriek",
    "subDomain": "Grove motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA48",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-9",
    "publisherGoalLabel": "loopspringen",
    "enduserLabel": null,
    "publisherGoalDescription": "springt vanuit stilstand van mat naar mat",
    "domain": "Grove motoriek",
    "subDomain": "Grove motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA49",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-10",
    "publisherGoalLabel": "touwtje springen",
    "enduserLabel": null,
    "publisherGoalDescription": "springt over een schommelend touw",
    "domain": "Grove motoriek",
    "subDomain": "Grove motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA410",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-11",
    "publisherGoalLabel": "mikken",
    "enduserLabel": null,
    "publisherGoalDescription": "gooit met een pittenzak tegen een grote, boven hoofdhoogte (2 meter) hangende krant",
    "domain": "Grove motoriek",
    "subDomain": "Grove motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA411",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-12",
    "publisherGoalLabel": "mikken",
    "enduserLabel": null,
    "publisherGoalDescription": "gooit met een bal pilonnen omver",
    "domain": "Grove motoriek",
    "subDomain": "Grove motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA412",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-13",
    "publisherGoalLabel": "mikken",
    "enduserLabel": null,
    "publisherGoalDescription": "mikt een bal of pittenzak in een open kast (max. 1,5 meter)",
    "domain": "Grove motoriek",
    "subDomain": "Grove motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA413",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-14",
    "publisherGoalLabel": "*rijden",
    "enduserLabel": null,
    "publisherGoalDescription": "fietsen op een driewieler",
    "domain": "Grove motoriek",
    "subDomain": "Grove motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA414",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-15",
    "publisherGoalLabel": "*glijden",
    "enduserLabel": null,
    "publisherGoalDescription": "glijden van een brede glijbaan zittend en via de rug",
    "domain": "Grove motoriek",
    "subDomain": "Grove motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA415",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-16",
    "publisherGoalLabel": "*mikken",
    "enduserLabel": null,
    "publisherGoalDescription": "werpen met een bal op een laken met gat erin (hoogte max. 1 meter)",
    "domain": "Grove motoriek",
    "subDomain": "Grove motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA416",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-17",
    "publisherGoalLabel": "*mikken",
    "enduserLabel": null,
    "publisherGoalDescription": "rollen met een bal tegen blokjes (max. 1,5 meter)",
    "domain": "Grove motoriek",
    "subDomain": "Grove motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA417",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-18",
    "publisherGoalLabel": "*vangen",
    "enduserLabel": null,
    "publisherGoalDescription": "vangen van een grote (zachte) bal",
    "domain": "Grove motoriek",
    "subDomain": "Grove motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA418",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-19",
    "publisherGoalLabel": "*belangrijke bewegingen",
    "enduserLabel": null,
    "publisherGoalDescription": "kruipen, liggen op de buik met het hoofd omhoog",
    "domain": "Grove motoriek",
    "subDomain": "Grove motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA419",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-20",
    "publisherGoalLabel": "*rollen",
    "enduserLabel": null,
    "publisherGoalDescription": "rollen (minimaal eenmaal) om de lengteas",
    "domain": "Grove motoriek",
    "subDomain": "Grove motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA422",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-23",
    "publisherGoalLabel": "Maakt grove bewegingen vanuit de elleboog",
    "enduserLabel": null,
    "publisherGoalDescription": "Maakt grove bewegingen vanuit de elleboog",
    "domain": "Grove motoriek",
    "subDomain": "Fijne motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA423",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-24",
    "publisherGoalLabel": "Tikt met duim (zonder een rondje te maken) o.a. tegen wijsvinger",
    "enduserLabel": null,
    "publisherGoalDescription": "Tikt met duim (zonder een rondje te maken) o.a. tegen wijsvinger",
    "domain": "Grove motoriek",
    "subDomain": "Fijne motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA424",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-25",
    "publisherGoalLabel": "Maakt gebruik van twee handen tijdens spelen en werken (doorgeven van de éne hand naar de andere hand of beide handen actief) ",
    "enduserLabel": null,
    "publisherGoalDescription": "Maakt gebruik van twee handen tijdens spelen en werken (doorgeven van de éne hand naar de andere hand of beide handen actief) ",
    "domain": "Grove motoriek",
    "subDomain": "Fijne motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA425",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-26",
    "publisherGoalLabel": "De bewegingen van beide lichaamshelften zijn elkaars spiegelbeeld (bijv. éne hand vuist, de andere hand maakt ook deze beweging)",
    "enduserLabel": null,
    "publisherGoalDescription": "De bewegingen van beide lichaamshelften zijn elkaars spiegelbeeld (bijv. éne hand vuist, de andere hand maakt ook deze beweging)",
    "domain": "Grove motoriek",
    "subDomain": "Fijne motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA426",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-27",
    "publisherGoalLabel": "*Experimenteren met knippen",
    "enduserLabel": null,
    "publisherGoalDescription": "*Experimenteren met knippen",
    "domain": "Grove motoriek",
    "subDomain": "Fijne motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA427",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-28",
    "publisherGoalLabel": "*Bouwen met kleine blokjes",
    "enduserLabel": null,
    "publisherGoalDescription": "*Bouwen met kleine blokjes",
    "domain": "Grove motoriek",
    "subDomain": "Fijne motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA428",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-29",
    "publisherGoalLabel": "*Scheuren van (grote, grove) stukken papier",
    "enduserLabel": null,
    "publisherGoalDescription": "*Scheuren van (grote, grove) stukken papier",
    "domain": "Grove motoriek",
    "subDomain": "Fijne motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA429",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-30",
    "publisherGoalLabel": "*Experimenteren met vouwen ",
    "enduserLabel": null,
    "publisherGoalDescription": "*Experimenteren met vouwen ",
    "domain": "Grove motoriek",
    "subDomain": "Fijne motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA430",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-31",
    "publisherGoalLabel": "*Werken met beide handen in zand, met blokjes, scheerschuim, mais e.d.",
    "enduserLabel": null,
    "publisherGoalDescription": "*Werken met beide handen in zand, met blokjes, scheerschuim, mais e.d.",
    "domain": "Grove motoriek",
    "subDomain": "Fijne motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA431",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-32",
    "publisherGoalLabel": "*Zelfstandig dichtmaken van een rits",
    "enduserLabel": null,
    "publisherGoalDescription": "*Zelfstandig dichtmaken van een rits",
    "domain": "Grove motoriek",
    "subDomain": "Fijne motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA432",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-33",
    "publisherGoalLabel": "*Experimenteren met klei",
    "enduserLabel": null,
    "publisherGoalDescription": "*Experimenteren met klei",
    "domain": "Grove motoriek",
    "subDomain": "Fijne motoriek - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA435",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-36",
    "publisherGoalLabel": "gevoelens",
    "enduserLabel": null,
    "publisherGoalDescription": "gebruikt eenvoudige emotiewoorden",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Besef van zichzelf - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA436",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-37",
    "publisherGoalLabel": "persoonskenmerken",
    "enduserLabel": null,
    "publisherGoalDescription": "benoemt wat het (niet) goed kan",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Besef van zichzelf - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA438",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-39",
    "publisherGoalLabel": "gevoelens hanteren",
    "enduserLabel": null,
    "publisherGoalDescription": "kan met hulp van een volwassene emoties reguleren",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Omgaan met zichzelf - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA439",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-40",
    "publisherGoalLabel": "impulscontrole",
    "enduserLabel": null,
    "publisherGoalDescription": "kan met hulp van een volwassene impulsen beheersen",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Omgaan met zichzelf - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA441",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-42",
    "publisherGoalLabel": "gevoelens",
    "enduserLabel": null,
    "publisherGoalDescription": "herkent gevoelens van een ander",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Besef van de ander - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA442",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-43",
    "publisherGoalLabel": "persoonskenmerken",
    "enduserLabel": null,
    "publisherGoalDescription": "benoemt verschillen tussen zichzelf en de ander",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Besef van de ander - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA444",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-45",
    "publisherGoalLabel": "aansluiten",
    "enduserLabel": null,
    "publisherGoalDescription": "gaat interactie aan met een ander",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Omgaan met de ander - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA445",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-46",
    "publisherGoalLabel": "conflicten",
    "enduserLabel": null,
    "publisherGoalDescription": "herkent de eigen grens als een ander daar overheen gaat",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Omgaan met de ander - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA446",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-47",
    "publisherGoalLabel": "samenwerken",
    "enduserLabel": null,
    "publisherGoalDescription": "heeft een eigen inbreng tijdens gezamenlijke activiteiten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Omgaan met de ander - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA448",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-49",
    "publisherGoalLabel": "weloverwogen kiezen",
    "enduserLabel": null,
    "publisherGoalDescription": "kiest op basis van eigen voorkeuren",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Keuzes maken - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA449",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "1-doelen-50",
    "publisherGoalLabel": "zelfstandigheid",
    "enduserLabel": null,
    "publisherGoalDescription": "pakt zelf materialen voor een taak en ruimt deze op",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Keuzes maken - 1",
    "tags": [
      "",
      "1-doelen",
      "-19--10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA51",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-2",
    "publisherGoalLabel": "handelen",
    "enduserLabel": null,
    "publisherGoalDescription": "maakt samen plannen voor spelscenario’s",
    "domain": "Spel",
    "subDomain": "Spel - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA52",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-3",
    "publisherGoalLabel": "rolgebruik",
    "enduserLabel": null,
    "publisherGoalDescription": "speelt interactief rollenspel binnen de afspraken",
    "domain": "Spel",
    "subDomain": "Spel - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA53",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-4",
    "publisherGoalLabel": "spelverhaal",
    "enduserLabel": null,
    "publisherGoalDescription": "kan meerdere rollen aannemen binnen thematisch rollenspel",
    "domain": "Spel",
    "subDomain": "Spel - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA54",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-5",
    "publisherGoalLabel": "speelduur",
    "enduserLabel": null,
    "publisherGoalDescription": "speelt een spelscenario van ± 15 minuten (in een rol)",
    "domain": "Spel",
    "subDomain": "Spel - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA55",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-6",
    "publisherGoalLabel": "*speeltaal",
    "enduserLabel": null,
    "publisherGoalDescription": "beschrijven van rollen, rollentaal en handelingen",
    "domain": "Spel",
    "subDomain": "Spel - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA58",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-9",
    "publisherGoalLabel": "oriëntatie op verhaal en tekst",
    "enduserLabel": null,
    "publisherGoalDescription": "legt platen uit een verhaal in de goede volgorde neer en vertelt het verhaal na",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA59",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-10",
    "publisherGoalLabel": "oriëntatie op verhaal en tekst",
    "enduserLabel": null,
    "publisherGoalDescription": "weet wat de hoofdcomponenten zijn in het verhaal (wie, wat en waar)",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA510",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-11",
    "publisherGoalLabel": "taalbewustzijn",
    "enduserLabel": null,
    "publisherGoalDescription": "kan fonemen (bijv. beginklank) als klankeenheden in woorden herkennen",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA511",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-12",
    "publisherGoalLabel": "oriëntatie op geschreven taal",
    "enduserLabel": null,
    "publisherGoalDescription": "herkent de letters van eigen naam en enkele van de themawoorden",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA512",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-13",
    "publisherGoalLabel": "visuele waarneming",
    "enduserLabel": null,
    "publisherGoalDescription": "kan 5 à 6 getoonde voorwerpen onthouden",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA513",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-14",
    "publisherGoalLabel": "*taalbewustzijn",
    "enduserLabel": null,
    "publisherGoalDescription": "fonemen als klankeenheden samenvoegen tot een woord",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA514",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-15",
    "publisherGoalLabel": "*taalbewustzijn",
    "enduserLabel": null,
    "publisherGoalDescription": "rijmen met (onzin)woorden",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA515",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-16",
    "publisherGoalLabel": "*taalbewustzijn",
    "enduserLabel": null,
    "publisherGoalDescription": "woorden in klankgroepen klappen",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA516",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-17",
    "publisherGoalLabel": "*oriëntatie op geschreven taal",
    "enduserLabel": null,
    "publisherGoalDescription": "naschrijven of naleggen van themawoorden met lettermateriaal",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA517",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-18",
    "publisherGoalLabel": "*leesplezier",
    "enduserLabel": null,
    "publisherGoalDescription": "mening geven over een voorgelezen verhaal",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA520",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-21",
    "publisherGoalLabel": "luisteren",
    "enduserLabel": null,
    "publisherGoalDescription": "vat samen in één zin wat het gehoord heeft",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA521",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-22",
    "publisherGoalLabel": "spreken",
    "enduserLabel": null,
    "publisherGoalDescription": "maakt eenvoudige zinnen, met gebruik van voegwoorden (omdat, en)",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA522",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-23",
    "publisherGoalLabel": "gesprekken",
    "enduserLabel": null,
    "publisherGoalDescription": "blijft bij het gespreksonderwerp",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA523",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-24",
    "publisherGoalLabel": "*woordenschat",
    "enduserLabel": null,
    "publisherGoalDescription": "leren en gebruiken van (nieuwe) woorden naar aanleiding van verhalen en/of een thema. de woorden liggen in de wereld om het kind en verder  buiten het kind",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA526",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-27",
    "publisherGoalLabel": "telrij",
    "enduserLabel": null,
    "publisherGoalDescription": "telt door vanaf verschillende getallen in de telrij tot en met 12",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA527",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-28",
    "publisherGoalLabel": "hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "lost eenvoudige splitsproblemen (handelend) op tot tenminste 5",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA528",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-29",
    "publisherGoalLabel": "getallen",
    "enduserLabel": null,
    "publisherGoalDescription": "kan de getalsymbolen 0 t/m 12 lezen",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA529",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-30",
    "publisherGoalLabel": "*telrij",
    "enduserLabel": null,
    "publisherGoalDescription": "terugtellen vanaf verschillende getallen in de telrij tot en met 12",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA530",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-31",
    "publisherGoalLabel": "*telrij",
    "enduserLabel": null,
    "publisherGoalDescription": "omgaan met begrippen zoals",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2a",
    "tags": [
      " verder, naast, door, terug en tussenin",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA531",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-32",
    "publisherGoalLabel": "*telrij",
    "enduserLabel": null,
    "publisherGoalDescription": "oefenen met rangtelwoorden als eerste, tweede, vierde en verkennen wanneer je die gebruikt",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA532",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-33",
    "publisherGoalLabel": "*hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "tellen van voorwerpen tot en met 15; synchroon en resultatief",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA533",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-34",
    "publisherGoalLabel": "*hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "representeren van hoeveelheden tot tenminste 5 (bijv. vingers, streepjes, stippen)",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA534",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-35",
    "publisherGoalLabel": "*hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "schatten van hoeveelheden tot 15",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA535",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-36",
    "publisherGoalLabel": "*getallen",
    "enduserLabel": null,
    "publisherGoalDescription": "onderzoeken van getalrelaties",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2a",
    "tags": [
      " buurgetallen",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA538",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-39",
    "publisherGoalLabel": "lengte en omtrek",
    "enduserLabel": null,
    "publisherGoalDescription": "ordent van kort naar lang en van laag naar hoog",
    "domain": "Meten",
    "subDomain": "Meten - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA539",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-40",
    "publisherGoalLabel": "tijd",
    "enduserLabel": null,
    "publisherGoalDescription": "kent de begrippen gisteren, vandaag, morgen en nu",
    "domain": "Meten",
    "subDomain": "Meten - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA540",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-41",
    "publisherGoalLabel": "geld",
    "enduserLabel": null,
    "publisherGoalDescription": "betaalt gepast tot minimaal 12 euro, met munten van 1 euro",
    "domain": "Meten",
    "subDomain": "Meten - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA541",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-42",
    "publisherGoalLabel": "*oppervlakte",
    "enduserLabel": null,
    "publisherGoalDescription": "ordenen van groot naar klein",
    "domain": "Meten",
    "subDomain": "Meten - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA542",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-43",
    "publisherGoalLabel": "*tijd",
    "enduserLabel": null,
    "publisherGoalDescription": "oefenen met de seizoenen van het jaar",
    "domain": "Meten",
    "subDomain": "Meten - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA543",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-44",
    "publisherGoalLabel": "*gewicht",
    "enduserLabel": null,
    "publisherGoalDescription": "ordenen van licht naar zwaar",
    "domain": "Meten",
    "subDomain": "Meten - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA544",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-45",
    "publisherGoalLabel": "*inhoud",
    "enduserLabel": null,
    "publisherGoalDescription": "ordenen van leeg naar vol",
    "domain": "Meten",
    "subDomain": "Meten - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA547",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-48",
    "publisherGoalLabel": "oriënteren in de ruimte",
    "enduserLabel": null,
    "publisherGoalDescription": "kent de begrippen dichtbij, veraf, tegenover en tussen",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA548",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-49",
    "publisherGoalLabel": "opereren met vormen en figuren",
    "enduserLabel": null,
    "publisherGoalDescription": "herkent de vormen driehoek, vierkant, cirkel en rechthoek in voorwerpen of figuren",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA549",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-50",
    "publisherGoalLabel": "*oriënteren in de ruimte",
    "enduserLabel": null,
    "publisherGoalDescription": "beschrijven van routes",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA550",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-51",
    "publisherGoalLabel": "*construeren",
    "enduserLabel": null,
    "publisherGoalDescription": "puzzels maken van 20 stukjes",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA551",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-52",
    "publisherGoalLabel": "*construeren",
    "enduserLabel": null,
    "publisherGoalDescription": "vouwen van 16 vierkantjes",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA552",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-53",
    "publisherGoalLabel": "*construeren",
    "enduserLabel": null,
    "publisherGoalDescription": "maken van creatieve bouwwerken",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA553",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-54",
    "publisherGoalLabel": "*opereren met vormen en figuren",
    "enduserLabel": null,
    "publisherGoalDescription": "experimenteren met vormen en figuren in spiegels en spiegeleffecten",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA554",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-55",
    "publisherGoalLabel": "*verbanden",
    "enduserLabel": null,
    "publisherGoalDescription": "gebruiken van staafdiagrammen",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 2a",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA557",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-58",
    "publisherGoalLabel": "Komt ontspannen over",
    "enduserLabel": null,
    "publisherGoalDescription": "Komt ontspannen over",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA558",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-59",
    "publisherGoalLabel": "Heeft plezier in wat het doet",
    "enduserLabel": null,
    "publisherGoalDescription": "Heeft plezier in wat het doet",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA559",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-60",
    "publisherGoalLabel": "Laat zelfvertrouwen zien",
    "enduserLabel": null,
    "publisherGoalDescription": "Laat zelfvertrouwen zien",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA560",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-61",
    "publisherGoalLabel": "Durft zichzelf te zijn in de groep",
    "enduserLabel": null,
    "publisherGoalDescription": "Durft zichzelf te zijn in de groep",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA562",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-63",
    "publisherGoalLabel": "Toont belangstelling voor activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Toont belangstelling voor activiteiten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA563",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-64",
    "publisherGoalLabel": "Laat concentratie zien bij activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Laat concentratie zien bij activiteiten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA564",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-65",
    "publisherGoalLabel": "Kan opgaan in activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Kan opgaan in activiteiten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA565",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2a-doelen-66",
    "publisherGoalLabel": "Zet door bij activiteiten, ook als het tegenzit",
    "enduserLabel": null,
    "publisherGoalDescription": "Zet door bij activiteiten, ook als het tegenzit",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "2a-doelen",
      "-9--5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA61",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-2",
    "publisherGoalLabel": "handelen",
    "enduserLabel": null,
    "publisherGoalDescription": "maakt samen plannen voor complexe spelscenario's",
    "domain": "Spel",
    "subDomain": "Spel - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA62",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-3",
    "publisherGoalLabel": "rolgebruik",
    "enduserLabel": null,
    "publisherGoalDescription": "laat interactief thematisch rollenspel zien volgens voorbedacht plan",
    "domain": "Spel",
    "subDomain": "Spel - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA63",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-4",
    "publisherGoalLabel": "spelverhaal",
    "enduserLabel": null,
    "publisherGoalDescription": "maakt vooraf plannen met anderen voor spelscenario's",
    "domain": "Spel",
    "subDomain": "Spel - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA64",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-5",
    "publisherGoalLabel": "speelduur",
    "enduserLabel": null,
    "publisherGoalDescription": "speelt een spelscenario van ± 20 minuten (in een rol)",
    "domain": "Spel",
    "subDomain": "Spel - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA65",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-6",
    "publisherGoalLabel": "*speeltaal",
    "enduserLabel": null,
    "publisherGoalDescription": "gebruiken van rolgebonden, academische taal in dialoog",
    "domain": "Spel",
    "subDomain": "Spel - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA68",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-9",
    "publisherGoalLabel": "oriëntatie op verhaal en tekst",
    "enduserLabel": null,
    "publisherGoalDescription": "weet de leesrichting van teksten (van links naar rechts en van boven naar beneden)",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA69",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-10",
    "publisherGoalLabel": "taalbewustzijn",
    "enduserLabel": null,
    "publisherGoalDescription": "kan fonemen als klankeenheden samenvoegen tot een woord (v-i-s = vis)",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA610",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-11",
    "publisherGoalLabel": "taalbewustzijn",
    "enduserLabel": null,
    "publisherGoalDescription": "herkent begin- en eindklank van een woord",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA611",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-12",
    "publisherGoalLabel": "taalbewustzijn",
    "enduserLabel": null,
    "publisherGoalDescription": "kan rijmen met bestaande woorden",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA612",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-13",
    "publisherGoalLabel": "oriëntatie op geschreven taal",
    "enduserLabel": null,
    "publisherGoalDescription": "herkent/schrijft 8-12 letters van eigen naam of themawoorden",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA613",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-14",
    "publisherGoalLabel": "visuele waarneming",
    "enduserLabel": null,
    "publisherGoalDescription": "ziet kleine verschillen tussen figuren (bijv. tussen letters/cijfers/afbeeldingen/voorwerpen)",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA614",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-15",
    "publisherGoalLabel": "*taalbewustzijn",
    "enduserLabel": null,
    "publisherGoalDescription": "onderscheiden van een letter, een woord en een zin",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA615",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-16",
    "publisherGoalLabel": "*taalbewustzijn",
    "enduserLabel": null,
    "publisherGoalDescription": "een reeks van vier woorden (themawoorden) nazeggen",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA616",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-17",
    "publisherGoalLabel": "*taalbewustzijn",
    "enduserLabel": null,
    "publisherGoalDescription": "een woord verdelen in klankeenheden (vis = v-i-s)",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA617",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-18",
    "publisherGoalLabel": "*leesplezier",
    "enduserLabel": null,
    "publisherGoalDescription": "voorkeur hebben voor bepaalde voorgelezen verhalen en boeken",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA620",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-21",
    "publisherGoalLabel": "luisteren",
    "enduserLabel": null,
    "publisherGoalDescription": "luistert naar en reageert op een ander",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA621",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-22",
    "publisherGoalLabel": "spreken",
    "enduserLabel": null,
    "publisherGoalDescription": "gebruikt complexere samengestelde zinnen met voegwoorden (omdat, of, maar)",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA622",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-23",
    "publisherGoalLabel": "gesprekken",
    "enduserLabel": null,
    "publisherGoalDescription": "geeft zijn mening over het gesprek en beargumenteert dit",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA623",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-24",
    "publisherGoalLabel": "*woordenschat",
    "enduserLabel": null,
    "publisherGoalDescription": "uitbreiden woordenschat n.a.v. thema en academische taal (praten over complexe onderwerpen)",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA626",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-27",
    "publisherGoalLabel": "telrij",
    "enduserLabel": null,
    "publisherGoalDescription": "telt door vanaf verschillende getallen in de telrij tot en met 20",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA627",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-28",
    "publisherGoalLabel": "hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "kan verkort tellen van hoeveelheden tot tenminste 12 door gebruik te maken van structuren (bijv. dobbelstenen)",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA628",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-29",
    "publisherGoalLabel": "getallen",
    "enduserLabel": null,
    "publisherGoalDescription": "kan getalsymbolen, telwoorden en hoeveelheden tot tenminste 12 koppelen aan elkaar",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA629",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-30",
    "publisherGoalLabel": "*telrij",
    "enduserLabel": null,
    "publisherGoalDescription": "verkort tellen met sprongen van twee (1,3,5; 2,4,6)",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA630",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-31",
    "publisherGoalLabel": "*telrij",
    "enduserLabel": null,
    "publisherGoalDescription": "hanteren van rangtelwoorden als eerste, tweede, derde t/m tiende",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA631",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-32",
    "publisherGoalLabel": "*hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "representeren van hoeveelheden tot tenminste 10 (bijv. vingers, streepjes, stippen)",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA632",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-33",
    "publisherGoalLabel": "*hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "herkennen van groepjes tot 6, zonder te tellen, door gebruik te maken van structuren (bijv. dobbelstenen)",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA633",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-34",
    "publisherGoalLabel": "*hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "vergelijken van hoeveelheden tot tenminste 12 door het leggen van 1-1 relaties en ordenen (meer, minder, evenveel, meeste, minste, veel, samen (bijv. staafdiagram))",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA634",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-35",
    "publisherGoalLabel": "*hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "oplossen van eenvoudige splitsproblemen (handelend) tot ten minste 8",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA635",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-36",
    "publisherGoalLabel": "*hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "schatten van hoeveelheden tot 20",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA636",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-37",
    "publisherGoalLabel": "*getallen",
    "enduserLabel": null,
    "publisherGoalDescription": "nadenken over \"nul\" als getal",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA637",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-38",
    "publisherGoalLabel": "*getallen",
    "enduserLabel": null,
    "publisherGoalDescription": "oefenen met de volgorde van de getallen in de getallenrij",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA640",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-41",
    "publisherGoalLabel": "lengte en omtrek",
    "enduserLabel": null,
    "publisherGoalDescription": "meet met een natuurlijke maat (bijv. hand of voet) en met informele instrumenten (bijv. touwtje of stroken)",
    "domain": "Meten",
    "subDomain": "Meten - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA641",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-42",
    "publisherGoalLabel": "tijd",
    "enduserLabel": null,
    "publisherGoalDescription": "vertelt met tijdsbegrippen zoals eerder, vroeger, later (bijv. bij weergave van een verhaal)",
    "domain": "Meten",
    "subDomain": "Meten - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA642",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-43",
    "publisherGoalLabel": "geld",
    "enduserLabel": null,
    "publisherGoalDescription": "betaalt gepast met munten van 1 en 2 euro",
    "domain": "Meten",
    "subDomain": "Meten - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA643",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-44",
    "publisherGoalLabel": "*lengte en omtrek",
    "enduserLabel": null,
    "publisherGoalDescription": "redeneren over lengte en omtrek in betekenisvolle situaties",
    "domain": "Meten",
    "subDomain": "Meten - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA644",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-45",
    "publisherGoalLabel": "*oppervlakte",
    "enduserLabel": null,
    "publisherGoalDescription": "vergelijken en ordenen van groot naar klein",
    "domain": "Meten",
    "subDomain": "Meten - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA645",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-46",
    "publisherGoalLabel": "*oppervlakte",
    "enduserLabel": null,
    "publisherGoalDescription": "redeneren over oppervlakte in betekenisvolle situaties",
    "domain": "Meten",
    "subDomain": "Meten - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA646",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-47",
    "publisherGoalLabel": "*tijd",
    "enduserLabel": null,
    "publisherGoalDescription": "aflezen van hele uren op een klok",
    "domain": "Meten",
    "subDomain": "Meten - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA647",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-48",
    "publisherGoalLabel": "*tijd",
    "enduserLabel": null,
    "publisherGoalDescription": "oefenen met enkele maanden van het jaar",
    "domain": "Meten",
    "subDomain": "Meten - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA648",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-49",
    "publisherGoalLabel": "*gewicht",
    "enduserLabel": null,
    "publisherGoalDescription": "ordenen van licht naar zwaar en redeneren over het waarom",
    "domain": "Meten",
    "subDomain": "Meten - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA649",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-50",
    "publisherGoalLabel": "*inhoud",
    "enduserLabel": null,
    "publisherGoalDescription": "halfvol inschenken van een beker",
    "domain": "Meten",
    "subDomain": "Meten - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA650",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-51",
    "publisherGoalLabel": "*temperatuur",
    "enduserLabel": null,
    "publisherGoalDescription": "redeneren over de begrippen warm en koud",
    "domain": "Meten",
    "subDomain": "Meten - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA651",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-52",
    "publisherGoalLabel": "*verhoudingen",
    "enduserLabel": null,
    "publisherGoalDescription": "verhoudingsgewijs ordenen (bijv. als je groter wordt moeten je kleren ook groter zijn)",
    "domain": "Meten",
    "subDomain": "Meten - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA654",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-55",
    "publisherGoalLabel": "oriënteren in de ruimte",
    "enduserLabel": null,
    "publisherGoalDescription": "kan eenvoudige plattegronden aflezen en uitleggen",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA655",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-56",
    "publisherGoalLabel": "construeren",
    "enduserLabel": null,
    "publisherGoalDescription": "kan met constructiemateriaal een voorbeeld namaken",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA656",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-57",
    "publisherGoalLabel": "opereren met vormen en figuren",
    "enduserLabel": null,
    "publisherGoalDescription": "sorteert voorwerpen op minimaal drie kenmerken (bijv. rood, dun vierkant)",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA657",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-58",
    "publisherGoalLabel": "*oriënteren in de ruimte",
    "enduserLabel": null,
    "publisherGoalDescription": "vertellen wat wel of niet zichtbaar is vanaf een bepaald standpunt",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA658",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-59",
    "publisherGoalLabel": "*construeren",
    "enduserLabel": null,
    "publisherGoalDescription": "redeneren over eenvoudige meetkundige problemen",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA659",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-60",
    "publisherGoalLabel": "*opereren met vormen en figuren",
    "enduserLabel": null,
    "publisherGoalDescription": "redeneren over vormen en figuren in passende probleemsituaties",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA660",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-61",
    "publisherGoalLabel": "*verhoudingen",
    "enduserLabel": null,
    "publisherGoalDescription": "verkennen van getalsmatige verhoudingen (bijv. 1 stoel heeft 4 poten, 2 stoelen hebben 8 poten)",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA661",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-62",
    "publisherGoalLabel": "*verbanden",
    "enduserLabel": null,
    "publisherGoalDescription": "aflezen van informatie uit een grafische voorstelling (bijv. met beelddiagram, staafdiagram)",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 2b",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA664",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-65",
    "publisherGoalLabel": "Komt ontspannen over",
    "enduserLabel": null,
    "publisherGoalDescription": "Komt ontspannen over",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA665",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-66",
    "publisherGoalLabel": "Heeft plezier in wat het doet",
    "enduserLabel": null,
    "publisherGoalDescription": "Heeft plezier in wat het doet",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA666",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-67",
    "publisherGoalLabel": "Laat zelfvertrouwen zien",
    "enduserLabel": null,
    "publisherGoalDescription": "Laat zelfvertrouwen zien",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA667",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-68",
    "publisherGoalLabel": "Durft zichzelf te zijn in de groep",
    "enduserLabel": null,
    "publisherGoalDescription": "Durft zichzelf te zijn in de groep",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA669",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-70",
    "publisherGoalLabel": "Toont belangstelling voor activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Toont belangstelling voor activiteiten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA670",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-71",
    "publisherGoalLabel": "Laat concentratie zien bij activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Laat concentratie zien bij activiteiten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA671",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-72",
    "publisherGoalLabel": "Kan opgaan in activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Kan opgaan in activiteiten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA672",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2b-doelen-73",
    "publisherGoalLabel": "Zet door bij activiteiten, ook als het tegenzit",
    "enduserLabel": null,
    "publisherGoalDescription": "Zet door bij activiteiten, ook als het tegenzit",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "2b-doelen",
      "-4-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA71",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-2",
    "publisherGoalLabel": "klimmen",
    "enduserLabel": null,
    "publisherGoalDescription": "klimt binnen een klautercircuit op verschillende hoogtes",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA72",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-3",
    "publisherGoalLabel": "huppelen",
    "enduserLabel": null,
    "publisherGoalDescription": "huppelt",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA73",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-4",
    "publisherGoalLabel": "balanceren",
    "enduserLabel": null,
    "publisherGoalDescription": "loopt over een schuin smal balanceervlak (evenwichtsbalk) zonder evenwichtsverstoring",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA74",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-5",
    "publisherGoalLabel": "balanceren",
    "enduserLabel": null,
    "publisherGoalDescription": "balanceert over een wip zonder evenwichtsverstoring",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA75",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-6",
    "publisherGoalLabel": "hinkelen",
    "enduserLabel": null,
    "publisherGoalDescription": "hinkelt 10 keer op voorkeursbeen",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA76",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-7",
    "publisherGoalLabel": "vrij springen",
    "enduserLabel": null,
    "publisherGoalDescription": "loopt via een bank omhoog en springt in een doorgaande beweging en komt met 2 benen tegelijk op de grond",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA77",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-8",
    "publisherGoalLabel": "steunspringen",
    "enduserLabel": null,
    "publisherGoalDescription": "voert de hazensprong op de bank uit",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA78",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-9",
    "publisherGoalLabel": "steunspringen",
    "enduserLabel": null,
    "publisherGoalDescription": "voert de wendsprong op de bank uit",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA79",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-10",
    "publisherGoalLabel": "loopspringen",
    "enduserLabel": null,
    "publisherGoalDescription": "springt vanuit een doorgaande beweging over lage hindernissen in een parcours",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA710",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-11",
    "publisherGoalLabel": "touwtje springen",
    "enduserLabel": null,
    "publisherGoalDescription": "springt in een touw gedraaid door de leerkracht",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA711",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-12",
    "publisherGoalLabel": "mikken",
    "enduserLabel": null,
    "publisherGoalDescription": "gooit van een grotere afstand (2 – 2,5 meter) een pittenzak/bal tegen een hoog hangende en kleinere krant",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA712",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-13",
    "publisherGoalLabel": "mikken",
    "enduserLabel": null,
    "publisherGoalDescription": "gooit van een grotere afstand (2 – 2,5 meter) met een bal pilonnen omver",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA713",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-14",
    "publisherGoalLabel": "mikken",
    "enduserLabel": null,
    "publisherGoalDescription": "mikt een bal of pittenzak vanaf een grotere afstand in een kast",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA714",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-15",
    "publisherGoalLabel": "*rijden",
    "enduserLabel": null,
    "publisherGoalDescription": "fietsen op tweewieler",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA715",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-16",
    "publisherGoalLabel": "*rijden",
    "enduserLabel": null,
    "publisherGoalDescription": "steppen",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA716",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-17",
    "publisherGoalLabel": "*glijden",
    "enduserLabel": null,
    "publisherGoalDescription": "glijden van een smalle en steile glijbaan op buik, rug en hurkend (met mat)",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA717",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-18",
    "publisherGoalLabel": "*mikken",
    "enduserLabel": null,
    "publisherGoalDescription": "werpen vanaf een grotere afstand van een bal op een laken/mat met gat erin of rondje erop",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA718",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-19",
    "publisherGoalLabel": "*mikken",
    "enduserLabel": null,
    "publisherGoalDescription": "rollen vanaf een grotere afstand van een bal tegen blokjes",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA719",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-20",
    "publisherGoalLabel": "*vangen",
    "enduserLabel": null,
    "publisherGoalDescription": "vangen van een kleine bal",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA720",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-21",
    "publisherGoalLabel": "*balvaardigheid",
    "enduserLabel": null,
    "publisherGoalDescription": "stuiteren met een bal",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA721",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-22",
    "publisherGoalLabel": "*rollen",
    "enduserLabel": null,
    "publisherGoalDescription": "rollen (minimaal tweemaal) om de lengteas",
    "domain": "Motoriek",
    "subDomain": "Grove motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA723",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-24",
    "publisherGoalLabel": "Maakt fijne bewegingen vanuit pols",
    "enduserLabel": null,
    "publisherGoalDescription": "Maakt fijne bewegingen vanuit pols",
    "domain": "Motoriek",
    "subDomain": "Fijne motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA724",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-25",
    "publisherGoalLabel": "Opponeert met de duim flexibel tegen vingers (maakt een rondje met duim en andere vingers)",
    "enduserLabel": null,
    "publisherGoalDescription": "Opponeert met de duim flexibel tegen vingers (maakt een rondje met duim en andere vingers)",
    "domain": "Motoriek",
    "subDomain": "Fijne motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA725",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-26",
    "publisherGoalLabel": "Maakt onafhankelijke bewegingen met de hand (bijv. éne hand op de knie slaan, andere hand op de schouder)",
    "enduserLabel": null,
    "publisherGoalDescription": "Maakt onafhankelijke bewegingen met de hand (bijv. éne hand op de knie slaan, andere hand op de schouder)",
    "domain": "Motoriek",
    "subDomain": "Fijne motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA726",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-27",
    "publisherGoalLabel": "Laat duidelijk een voorkeurshand zien",
    "enduserLabel": null,
    "publisherGoalDescription": "Laat duidelijk een voorkeurshand zien",
    "domain": "Motoriek",
    "subDomain": "Fijne motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA727",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-28",
    "publisherGoalLabel": "Maakt bewegingen die over de middenlijn gaan rond 6/6,5 jaar (bijv. sla met je linkerhand op je rechterknie e.d.)",
    "enduserLabel": null,
    "publisherGoalDescription": "Maakt bewegingen die over de middenlijn gaan rond 6/6,5 jaar (bijv. sla met je linkerhand op je rechterknie e.d.)",
    "domain": "Motoriek",
    "subDomain": "Fijne motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA728",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-29",
    "publisherGoalLabel": "*Knippen langs een gebogen lijn ",
    "enduserLabel": null,
    "publisherGoalDescription": "*Knippen langs een gebogen lijn ",
    "domain": "Motoriek",
    "subDomain": "Fijne motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA729",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-30",
    "publisherGoalLabel": "*Knopen open-/dichtmaken",
    "enduserLabel": null,
    "publisherGoalDescription": "*Knopen open-/dichtmaken",
    "domain": "Motoriek",
    "subDomain": "Fijne motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA730",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-31",
    "publisherGoalLabel": "*Kleuren binnen de lijntjes",
    "enduserLabel": null,
    "publisherGoalDescription": "*Kleuren binnen de lijntjes",
    "domain": "Motoriek",
    "subDomain": "Fijne motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA731",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-32",
    "publisherGoalLabel": "*Werken met knijpers en pincetten ",
    "enduserLabel": null,
    "publisherGoalDescription": "*Werken met knijpers en pincetten ",
    "domain": "Motoriek",
    "subDomain": "Fijne motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA732",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-33",
    "publisherGoalLabel": "*Rijgen van kleine kralen aan een koord",
    "enduserLabel": null,
    "publisherGoalDescription": "*Rijgen van kleine kralen aan een koord",
    "domain": "Motoriek",
    "subDomain": "Fijne motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA733",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-34",
    "publisherGoalLabel": "*Scheuren van papier in reepjes/stukjes ",
    "enduserLabel": null,
    "publisherGoalDescription": "*Scheuren van papier in reepjes/stukjes ",
    "domain": "Motoriek",
    "subDomain": "Fijne motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA734",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-35",
    "publisherGoalLabel": "*Scherp en nauwkeurig vouwen",
    "enduserLabel": null,
    "publisherGoalDescription": "*Scherp en nauwkeurig vouwen",
    "domain": "Motoriek",
    "subDomain": "Fijne motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA735",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-36",
    "publisherGoalLabel": "*Maken van schrijfpatronen in een rechte lijn op A3 formaat papier ",
    "enduserLabel": null,
    "publisherGoalDescription": "*Maken van schrijfpatronen in een rechte lijn op A3 formaat papier ",
    "domain": "Motoriek",
    "subDomain": "Fijne motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA736",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-37",
    "publisherGoalLabel": "*Veters vastmaken",
    "enduserLabel": null,
    "publisherGoalDescription": "*Veters vastmaken",
    "domain": "Motoriek",
    "subDomain": "Fijne motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA737",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-38",
    "publisherGoalLabel": "*Hebben van een goede pengreep (rond 6 jaar)",
    "enduserLabel": null,
    "publisherGoalDescription": "*Hebben van een goede pengreep (rond 6 jaar)",
    "domain": "Motoriek",
    "subDomain": "Fijne motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA738",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-39",
    "publisherGoalLabel": "*Verfijnd werken met klei",
    "enduserLabel": null,
    "publisherGoalDescription": "*Verfijnd werken met klei",
    "domain": "Motoriek",
    "subDomain": "Fijne motoriek - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA741",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-42",
    "publisherGoalLabel": "gevoelens",
    "enduserLabel": null,
    "publisherGoalDescription": "benoemt in een situatie gevoelens van zichzelf",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Besef van zichzelf - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA742",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-43",
    "publisherGoalLabel": "persoonskenmerken",
    "enduserLabel": null,
    "publisherGoalDescription": "benoemt vaardigheden en kwaliteiten van zichzelf",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Besef van zichzelf - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA744",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-45",
    "publisherGoalLabel": "gevoelens hanteren",
    "enduserLabel": null,
    "publisherGoalDescription": "kan in terugkerende situaties zelf zijn emoties reguleren",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Omgaan met zichzelf - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA745",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-46",
    "publisherGoalLabel": "impulscontrole",
    "enduserLabel": null,
    "publisherGoalDescription": "kan een impulsieve reactie in een lastige situatie uitstellen",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Omgaan met zichzelf - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA747",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-48",
    "publisherGoalLabel": "gevoelens",
    "enduserLabel": null,
    "publisherGoalDescription": "benoemt gevoelens van een ander",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Besef van de ander - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA748",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-49",
    "publisherGoalLabel": "persoonskenmerken",
    "enduserLabel": null,
    "publisherGoalDescription": "herkent vaardigheden en kwaliteiten bij de ander",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Besef van de ander - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA750",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-51",
    "publisherGoalLabel": "aansluiten",
    "enduserLabel": null,
    "publisherGoalDescription": "heeft voorkeur voor een aantal klasgenoten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Omgaan met de ander - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA751",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-52",
    "publisherGoalLabel": "conflicten",
    "enduserLabel": null,
    "publisherGoalDescription": "benoemt eigen grenzen in een situatie",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Omgaan met de ander - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA752",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-53",
    "publisherGoalLabel": "samenwerken",
    "enduserLabel": null,
    "publisherGoalDescription": "bedenkt regels en afspraken bij gezamenlijke activiteiten en houdt zich hieraan",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Omgaan met de ander - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA754",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-55",
    "publisherGoalLabel": "weloverwogen kiezen",
    "enduserLabel": null,
    "publisherGoalDescription": "kiest en blijft bij de eigen keuze",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Keuzes maken - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA755",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "2-doelen-56",
    "publisherGoalLabel": "zelfstandigheid",
    "enduserLabel": null,
    "publisherGoalDescription": "voert meerdere taken achter elkaar uit",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Keuzes maken - 2",
    "tags": [
      "",
      "2-doelen",
      "-9-0"
    ],
    "maxValue": 1
  },
  {
    "id": "GA81",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-2",
    "publisherGoalLabel": "*spelverhaal",
    "enduserLabel": null,
    "publisherGoalDescription": "samen opbouwen van een spelscript en bedenken van spelregels",
    "domain": "Spel",
    "subDomain": "Spel - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA82",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-3",
    "publisherGoalLabel": "*speelduur",
    "enduserLabel": null,
    "publisherGoalDescription": "onderbroken spel weer oppakken",
    "domain": "Spel",
    "subDomain": "Spel - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA85",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-6",
    "publisherGoalLabel": "Herkent en leest 20 letters die aangeboden zijn (eerder observeren; rond de herfstsignalering)",
    "enduserLabel": null,
    "publisherGoalDescription": "Herkent en leest 20 letters die aangeboden zijn (eerder observeren; rond de herfstsignalering)",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA86",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-7",
    "publisherGoalLabel": "Herkent en leest vlot alle letters die aangeboden zijn (december-januari)",
    "enduserLabel": null,
    "publisherGoalDescription": "Herkent en leest vlot alle letters die aangeboden zijn (december-januari)",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA87",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-8",
    "publisherGoalLabel": "Herkent en leest de klankzuivere woorden (globaal-woorden) die aangeboden zijn binnen het thema (mkm-woorden)",
    "enduserLabel": null,
    "publisherGoalDescription": "Herkent en leest de klankzuivere woorden (globaal-woorden) die aangeboden zijn binnen het thema (mkm-woorden)",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA88",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-9",
    "publisherGoalLabel": "Herkent en leest vlot mkmm- en mmkm- woorden",
    "enduserLabel": null,
    "publisherGoalDescription": "Herkent en leest vlot mkmm- en mmkm- woorden",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA89",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-10",
    "publisherGoalLabel": "Herkent en leest vlot twee medeklinkers vooraan/achteraan mmkmm",
    "enduserLabel": null,
    "publisherGoalDescription": "Herkent en leest vlot twee medeklinkers vooraan/achteraan mmkmm",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA810",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-11",
    "publisherGoalLabel": "Herkent en leest de woorden met de lange klanken aa, ee, oo en uu",
    "enduserLabel": null,
    "publisherGoalDescription": "Herkent en leest de woorden met de lange klanken aa, ee, oo en uu",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA811",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-12",
    "publisherGoalLabel": "Herkent en leest de woorden met de tweetekenklanken oe, eu, au, ie, ij en ei",
    "enduserLabel": null,
    "publisherGoalDescription": "Herkent en leest de woorden met de tweetekenklanken oe, eu, au, ie, ij en ei",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA812",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-13",
    "publisherGoalLabel": "Herkent en leest direct de lidwoorden de, het en een",
    "enduserLabel": null,
    "publisherGoalDescription": "Herkent en leest direct de lidwoorden de, het en een",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA813",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-14",
    "publisherGoalLabel": "Leest zinnen van ongeveer zes woorden, zonder hoofdletters",
    "enduserLabel": null,
    "publisherGoalDescription": "Leest zinnen van ongeveer zes woorden, zonder hoofdletters",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA814",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-15",
    "publisherGoalLabel": "*oriëntatie op verhaal en tekst",
    "enduserLabel": null,
    "publisherGoalDescription": "geven van een mondelinge samenvatting van een gelezen verhaal",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA815",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-16",
    "publisherGoalLabel": "*oriëntatie op verhaal en tekst",
    "enduserLabel": null,
    "publisherGoalDescription": "weten waar het antwoord gevonden kan worden op vragen gerelateerd aan het thema",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA816",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-17",
    "publisherGoalLabel": "*oriëntatie op geschreven taal",
    "enduserLabel": null,
    "publisherGoalDescription": "zelf teksten schrijven over het thema n.a.v. boeken en teksten",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA817",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-18",
    "publisherGoalLabel": "*oriëntatie op geschreven taal",
    "enduserLabel": null,
    "publisherGoalDescription": "maken van eigen prentenboek passend bij het thema",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA818",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-19",
    "publisherGoalLabel": "*oriëntatie op geschreven taal",
    "enduserLabel": null,
    "publisherGoalDescription": "zelfstandig lezen van prentenboeken, eigen en andermans teksten",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA819",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-20",
    "publisherGoalLabel": "*leesplezier",
    "enduserLabel": null,
    "publisherGoalDescription": "zelf boeken-verhalen kiezen om 'zelf' in te lezen",
    "domain": "Taal",
    "subDomain": "Geletterdheid - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA821",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-22",
    "publisherGoalLabel": "Schrijft woorden na van het thema",
    "enduserLabel": null,
    "publisherGoalDescription": "Schrijft woorden na van het thema",
    "domain": "Taal",
    "subDomain": "Spelling/schrijven - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA822",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-23",
    "publisherGoalLabel": "Schrijft 20 letters die aangeboden zijn rondom het thema (rond herfstsignalering observeren)",
    "enduserLabel": null,
    "publisherGoalDescription": "Schrijft 20 letters die aangeboden zijn rondom het thema (rond herfstsignalering observeren)",
    "domain": "Taal",
    "subDomain": "Spelling/schrijven - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA823",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-24",
    "publisherGoalLabel": "Schrijft woorden bij werkjes die aangeboden zijn bij het thema",
    "enduserLabel": null,
    "publisherGoalDescription": "Schrijft woorden bij werkjes die aangeboden zijn bij het thema",
    "domain": "Taal",
    "subDomain": "Spelling/schrijven - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA824",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-25",
    "publisherGoalLabel": "Schrijft woorden correct die klankzuiver zijn aangeboden ",
    "enduserLabel": null,
    "publisherGoalDescription": "Schrijft woorden correct die klankzuiver zijn aangeboden ",
    "domain": "Taal",
    "subDomain": "Spelling/schrijven - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA825",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-26",
    "publisherGoalLabel": "Schrijft woorden met dubbele klinkers, zoals aa, oe, ei, au, ou",
    "enduserLabel": null,
    "publisherGoalDescription": "Schrijft woorden met dubbele klinkers, zoals aa, oe, ei, au, ou",
    "domain": "Taal",
    "subDomain": "Spelling/schrijven - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA826",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-27",
    "publisherGoalLabel": "Schrijft woorden met lidwoorden",
    "enduserLabel": null,
    "publisherGoalDescription": "Schrijft woorden met lidwoorden",
    "domain": "Taal",
    "subDomain": "Spelling/schrijven - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA827",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-28",
    "publisherGoalLabel": "Schrijft mkm-woorden",
    "enduserLabel": null,
    "publisherGoalDescription": "Schrijft mkm-woorden",
    "domain": "Taal",
    "subDomain": "Spelling/schrijven - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA828",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-29",
    "publisherGoalLabel": "Herkent een spellingsfout in een woord  ",
    "enduserLabel": null,
    "publisherGoalDescription": "Herkent een spellingsfout in een woord  ",
    "domain": "Taal",
    "subDomain": "Spelling/schrijven - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA829",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-30",
    "publisherGoalLabel": "*Schrijven van eenvoudige functionele teksten, zoals boodschappenlijstjes enz.",
    "enduserLabel": null,
    "publisherGoalDescription": "*Schrijven van eenvoudige functionele teksten, zoals boodschappenlijstjes enz.",
    "domain": "Taal",
    "subDomain": "Spelling/schrijven - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA832",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-33",
    "publisherGoalLabel": "telrij",
    "enduserLabel": null,
    "publisherGoalDescription": "telt verkort met sprongen van twee tot 20",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA833",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-34",
    "publisherGoalLabel": "telrij",
    "enduserLabel": null,
    "publisherGoalDescription": "telt verkort met sprongen van vijf tot 20",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA834",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-35",
    "publisherGoalLabel": "telrij",
    "enduserLabel": null,
    "publisherGoalDescription": "kan de telrij tot 50 opzeggen",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA835",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-36",
    "publisherGoalLabel": "hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "kan groepjes maken van 5 en 10",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA836",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-37",
    "publisherGoalLabel": "hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "kent de splitsingen tot en met 6 uit het hoofd",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA837",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-38",
    "publisherGoalLabel": "getallen",
    "enduserLabel": null,
    "publisherGoalDescription": "kan de getallen 1 t/m 10 schrijven",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA838",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-39",
    "publisherGoalLabel": "getallen",
    "enduserLabel": null,
    "publisherGoalDescription": "benoemt buurgetallen tot tenminste 20",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA839",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-40",
    "publisherGoalLabel": "getallen",
    "enduserLabel": null,
    "publisherGoalDescription": "kan de getallen plaatsen op de getallenlijn t/m 20",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA840",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-41",
    "publisherGoalLabel": "bewerkingen",
    "enduserLabel": null,
    "publisherGoalDescription": "optellen en aftrekken",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3a",
    "tags": [
      " kan eenvoudige optel- en aftrekproblemen in een context met hoeveelheden t/m tenminste 12 (handelend) oplossen",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA841",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-42",
    "publisherGoalLabel": "bewerkingen",
    "enduserLabel": null,
    "publisherGoalDescription": "delen",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3a",
    "tags": [
      " kan eenvoudige verdelingen maken in een context met hoeveelheden tot tenminste 12",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA842",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-43",
    "publisherGoalLabel": "*hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "getalbeelden op rekenrek zetten in één greep",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA843",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-44",
    "publisherGoalLabel": "*hoeveelheden",
    "enduserLabel": null,
    "publisherGoalDescription": "splitsingen tot en met 10",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA844",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-45",
    "publisherGoalLabel": "*bewerkingen",
    "enduserLabel": null,
    "publisherGoalDescription": "tekening/verhaal maken bij de som en een som bij de tekening of verhaal",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA845",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-46",
    "publisherGoalLabel": "*bewerkingen",
    "enduserLabel": null,
    "publisherGoalDescription": "gebruiken van rekentaal zoals +/-/=",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA848",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-49",
    "publisherGoalLabel": "lengte en omtrek",
    "enduserLabel": null,
    "publisherGoalDescription": "meet lengte met een liniaal",
    "domain": "Meten",
    "subDomain": "Meten - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA849",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-50",
    "publisherGoalLabel": "tijd",
    "enduserLabel": null,
    "publisherGoalDescription": "leest hele uren af van analoge en digitale klok",
    "domain": "Meten",
    "subDomain": "Meten - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA850",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-51",
    "publisherGoalLabel": "geld",
    "enduserLabel": null,
    "publisherGoalDescription": "betaalt gepast met 1 en 2 euro munten en met biljetten van 5",
    "domain": "Meten",
    "subDomain": "Meten - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA851",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-52",
    "publisherGoalLabel": "gewicht",
    "enduserLabel": null,
    "publisherGoalDescription": "weegt met een balansweegschaal en vergelijkt resultaten met elkaar",
    "domain": "Meten",
    "subDomain": "Meten - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA852",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-53",
    "publisherGoalLabel": "*lengte en omtrek",
    "enduserLabel": null,
    "publisherGoalDescription": "ervaren dat afspreken van een vaste maat voorwaarde is voor het eerlijk meten, vergelijken en ordenen",
    "domain": "Meten",
    "subDomain": "Meten - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA853",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-54",
    "publisherGoalLabel": "*oppervlakte",
    "enduserLabel": null,
    "publisherGoalDescription": "ontwerpen van figuren met eenzelfde oppervlakte m.b.v. vierkanten en ruiten",
    "domain": "Meten",
    "subDomain": "Meten - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA854",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-55",
    "publisherGoalLabel": "*tijd",
    "enduserLabel": null,
    "publisherGoalDescription": "uren van een analoge klok verbinden aan momenten van de dag (bijv. een uur later, uur eerder)",
    "domain": "Meten",
    "subDomain": "Meten - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA855",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-56",
    "publisherGoalLabel": "*tijd",
    "enduserLabel": null,
    "publisherGoalDescription": "aflezen van hele en halve uren op analoge en digitale klok",
    "domain": "Meten",
    "subDomain": "Meten - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA856",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-57",
    "publisherGoalLabel": "*inhoud",
    "enduserLabel": null,
    "publisherGoalDescription": "gelijk verdelen van hoeveelheden",
    "domain": "Meten",
    "subDomain": "Meten - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA857",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-58",
    "publisherGoalLabel": "*temperatuur",
    "enduserLabel": null,
    "publisherGoalDescription": "gebruiken van een thermometer (binnen of buiten)",
    "domain": "Meten",
    "subDomain": "Meten - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA860",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-61",
    "publisherGoalLabel": "oriënteren in de ruimte",
    "enduserLabel": null,
    "publisherGoalDescription": "kan een route volgen aan de hand van een plattegrond",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA861",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-62",
    "publisherGoalLabel": "construeren",
    "enduserLabel": null,
    "publisherGoalDescription": "kan het aantal blokjes van een bouwwerk bepalen, ook die je niet kan zien",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA862",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-63",
    "publisherGoalLabel": "verbanden",
    "enduserLabel": null,
    "publisherGoalDescription": "kan informatie aflezen uit een grafische voorstelling (bijv. beeld- en staafdiagram)",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA863",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-64",
    "publisherGoalLabel": "*oriënteren in de ruimte",
    "enduserLabel": null,
    "publisherGoalDescription": "uitleggen hoe een voorwerp eruit ziet vanaf een ander standpunt",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA864",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-65",
    "publisherGoalLabel": "*construeren",
    "enduserLabel": null,
    "publisherGoalDescription": "blokkenbouwwerk nabouwen van een tekening en een tekening maken van een blokkenbouwwerk",
    "domain": "Meetkunde",
    "subDomain": "Meetkunde - 3a",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA867",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-68",
    "publisherGoalLabel": "Komt ontspannen over",
    "enduserLabel": null,
    "publisherGoalDescription": "Komt ontspannen over",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA868",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-69",
    "publisherGoalLabel": "Heeft plezier in wat het doet",
    "enduserLabel": null,
    "publisherGoalDescription": "Heeft plezier in wat het doet",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA869",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-70",
    "publisherGoalLabel": "Laat zelfvertrouwen zien",
    "enduserLabel": null,
    "publisherGoalDescription": "Laat zelfvertrouwen zien",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA870",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-71",
    "publisherGoalLabel": "Durft zichzelf te zijn in de groep",
    "enduserLabel": null,
    "publisherGoalDescription": "Durft zichzelf te zijn in de groep",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA872",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-73",
    "publisherGoalLabel": "Toont belangstelling voor activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Toont belangstelling voor activiteiten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA873",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-74",
    "publisherGoalLabel": "Laat concentratie zien bij activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Laat concentratie zien bij activiteiten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA874",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-75",
    "publisherGoalLabel": "Kan opgaan in activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Kan opgaan in activiteiten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA875",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3a-doelen-76",
    "publisherGoalLabel": "Zet door bij activiteiten, ook als het tegenzit",
    "enduserLabel": null,
    "publisherGoalDescription": "Zet door bij activiteiten, ook als het tegenzit",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "3a-doelen",
      "1-5"
    ],
    "maxValue": 1
  },
  {
    "id": "GA91",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-2",
    "publisherGoalLabel": "Herkent en leest vlot twee en drie medeklinkers vooraan/achteraan mmmkm-en mkmmm-woorden",
    "enduserLabel": null,
    "publisherGoalDescription": "Herkent en leest vlot twee en drie medeklinkers vooraan/achteraan mmmkm-en mkmmm-woorden",
    "domain": "Geletterdheid",
    "subDomain": "Geletterdheid - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA92",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-3",
    "publisherGoalLabel": "Herkent en leest vlot samengestelde woorden of tweelettergrepige woorden",
    "enduserLabel": null,
    "publisherGoalDescription": "Herkent en leest vlot samengestelde woorden of tweelettergrepige woorden",
    "domain": "Geletterdheid",
    "subDomain": "Geletterdheid - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA93",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-4",
    "publisherGoalLabel": "Herkent en leest alle klankgroep-woorden (lange en korte klank, medeklinker en tweetekenklank)",
    "enduserLabel": null,
    "publisherGoalDescription": "Herkent en leest alle klankgroep-woorden (lange en korte klank, medeklinker en tweetekenklank)",
    "domain": "Geletterdheid",
    "subDomain": "Geletterdheid - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA94",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-5",
    "publisherGoalLabel": "Herkent en leest woorden met medeklinkercluster, zoals eur, eer, oor",
    "enduserLabel": null,
    "publisherGoalDescription": "Herkent en leest woorden met medeklinkercluster, zoals eur, eer, oor",
    "domain": "Geletterdheid",
    "subDomain": "Geletterdheid - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA95",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-6",
    "publisherGoalLabel": "Herkent en leest verkleinwoorden -je, -tje en -ptje",
    "enduserLabel": null,
    "publisherGoalDescription": "Herkent en leest verkleinwoorden -je, -tje en -ptje",
    "domain": "Geletterdheid",
    "subDomain": "Geletterdheid - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA96",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-7",
    "publisherGoalLabel": "Herkent en leest de woorden met c als s en woorden met ch als g",
    "enduserLabel": null,
    "publisherGoalDescription": "Herkent en leest de woorden met c als s en woorden met ch als g",
    "domain": "Geletterdheid",
    "subDomain": "Geletterdheid - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA97",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-8",
    "publisherGoalLabel": "Herkent en leest woorden die beginnen met sch- en schr-",
    "enduserLabel": null,
    "publisherGoalDescription": "Herkent en leest woorden die beginnen met sch- en schr-",
    "domain": "Geletterdheid",
    "subDomain": "Geletterdheid - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA98",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-9",
    "publisherGoalLabel": "Herkent en leest vlot een eenlettergrepig woord dat eindigt op dt, ng of nk",
    "enduserLabel": null,
    "publisherGoalDescription": "Herkent en leest vlot een eenlettergrepig woord dat eindigt op dt, ng of nk",
    "domain": "Geletterdheid",
    "subDomain": "Geletterdheid - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA99",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-10",
    "publisherGoalLabel": "Herkent en leest woorden met aai, ooi en oei",
    "enduserLabel": null,
    "publisherGoalDescription": "Herkent en leest woorden met aai, ooi en oei",
    "domain": "Geletterdheid",
    "subDomain": "Geletterdheid - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA910",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-11",
    "publisherGoalLabel": "Herkent en leest woorden met -uw, -eeuw, - ieuw",
    "enduserLabel": null,
    "publisherGoalDescription": "Herkent en leest woorden met -uw, -eeuw, - ieuw",
    "domain": "Geletterdheid",
    "subDomain": "Geletterdheid - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA911",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-12",
    "publisherGoalLabel": "Leest zinnen van ongeveer 8 tot 10 woorden, met hoofdletters",
    "enduserLabel": null,
    "publisherGoalDescription": "Leest zinnen van ongeveer 8 tot 10 woorden, met hoofdletters",
    "domain": "Geletterdheid",
    "subDomain": "Geletterdheid - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA914",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-15",
    "publisherGoalLabel": "Schrijft alle letters die aangeboden zijn rondom het thema",
    "enduserLabel": null,
    "publisherGoalDescription": "Schrijft alle letters die aangeboden zijn rondom het thema",
    "domain": "Spelling/schrijven",
    "subDomain": "Spelling/schrijven - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA915",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-16",
    "publisherGoalLabel": "Schrijft zinnen met woorden van het thema ",
    "enduserLabel": null,
    "publisherGoalDescription": "Schrijft zinnen met woorden van het thema ",
    "domain": "Spelling/schrijven",
    "subDomain": "Spelling/schrijven - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA916",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-17",
    "publisherGoalLabel": "Schrijft mkmm- en mmkm-woorden",
    "enduserLabel": null,
    "publisherGoalDescription": "Schrijft mkmm- en mmkm-woorden",
    "domain": "Spelling/schrijven",
    "subDomain": "Spelling/schrijven - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA917",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-18",
    "publisherGoalLabel": "Schrijft woorden met twee medeklinkers vooraan/achteraan mmkmm",
    "enduserLabel": null,
    "publisherGoalDescription": "Schrijft woorden met twee medeklinkers vooraan/achteraan mmkmm",
    "domain": "Spelling/schrijven",
    "subDomain": "Spelling/schrijven - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA918",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-19",
    "publisherGoalLabel": "Herkent een spellingsfout in een zelf geschreven zin ",
    "enduserLabel": null,
    "publisherGoalDescription": "Herkent een spellingsfout in een zelf geschreven zin ",
    "domain": "Spelling/schrijven",
    "subDomain": "Spelling/schrijven - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA919",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-20",
    "publisherGoalLabel": "*Afschrijven van een voorgestructureerde tekst (bijv. een verhaaltje afschrijven)",
    "enduserLabel": null,
    "publisherGoalDescription": "*Afschrijven van een voorgestructureerde tekst (bijv. een verhaaltje afschrijven)",
    "domain": "Spelling/schrijven",
    "subDomain": "Spelling/schrijven - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA920",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-21",
    "publisherGoalLabel": "*Schrijven van een eenvoudige tekst naar aanleiding van een plaat over het thema",
    "enduserLabel": null,
    "publisherGoalDescription": "*Schrijven van een eenvoudige tekst naar aanleiding van een plaat over het thema",
    "domain": "Spelling/schrijven",
    "subDomain": "Spelling/schrijven - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA923",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-24",
    "publisherGoalLabel": "telrij",
    "enduserLabel": null,
    "publisherGoalDescription": "kan de telrij tot 100 opzeggen",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA924",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-25",
    "publisherGoalLabel": "telrij",
    "enduserLabel": null,
    "publisherGoalDescription": "kan vanuit elk getal verder en terug tellen tot 50",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA925",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-26",
    "publisherGoalLabel": "getallen",
    "enduserLabel": null,
    "publisherGoalDescription": "kan de getallen op de getallenlijn zetten in tientallen van 10 tot 100",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA926",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-27",
    "publisherGoalLabel": "getallen",
    "enduserLabel": null,
    "publisherGoalDescription": "kan de getallen 0 tot 100 lezen en uitspreken",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA927",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-28",
    "publisherGoalLabel": "getallen",
    "enduserLabel": null,
    "publisherGoalDescription": "kan de getallen 11 t/m 20 schrijven",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA928",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-29",
    "publisherGoalLabel": "bewerkingen",
    "enduserLabel": null,
    "publisherGoalDescription": "kent de optellingen, aftrekkingen en splitsingen t/m 10 uit het hoofd",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA929",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-30",
    "publisherGoalLabel": "bewerkingen",
    "enduserLabel": null,
    "publisherGoalDescription": "kan een som uit een verhaal halen en een verhaal uit een som",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA930",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-31",
    "publisherGoalLabel": "bewerkingen",
    "enduserLabel": null,
    "publisherGoalDescription": "kan optellen en aftrekken t/m 20 met behulp van strategieën (bijv. dubbelen, verwisselen, of aanvullen tot 10)",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA931",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-32",
    "publisherGoalLabel": "vermenigvuldigen",
    "enduserLabel": null,
    "publisherGoalDescription": "kan hoeveelheden verdubbelen en tellen met groepjes",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA932",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-33",
    "publisherGoalLabel": "delen",
    "enduserLabel": null,
    "publisherGoalDescription": "kan hoeveelheden halveren en splitsen in groepjes",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA933",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-34",
    "publisherGoalLabel": "*telrij",
    "enduserLabel": null,
    "publisherGoalDescription": "verder tellen vanuit elk getal tot 100",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA934",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-35",
    "publisherGoalLabel": "*telrij",
    "enduserLabel": null,
    "publisherGoalDescription": "oefenen met getallen die dichtbij of verder uit elkaar liggen in de getallenrij tot tenminste 20 (bijv. ‘welk getal ligt dichterbij 10",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3b",
    "tags": [
      " 13 of 5?')",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA935",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-36",
    "publisherGoalLabel": "*bewerkingen",
    "enduserLabel": null,
    "publisherGoalDescription": "oefenen met de relatie tussen optellen, aftrekken, splitsen en  toepassen (bijv. 2 + 5 = 7, 7 - 5 = 2, 7 = 5 + 2)",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA936",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-37",
    "publisherGoalLabel": "*bewerkingen",
    "enduserLabel": null,
    "publisherGoalDescription": "uit het hoofd automatiseren van de optellingen, aftrekkingen en splitsingen t/m 20",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA937",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-38",
    "publisherGoalLabel": "*bewerkingen",
    "enduserLabel": null,
    "publisherGoalDescription": "kritisch denken en redeneren over het rekenen tot ten minste 20 in betekenisvolle probleemsituaties",
    "domain": "Rekenen",
    "subDomain": "Tellen en getalbegrip - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA940",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-41",
    "publisherGoalLabel": "lengte en omtrek",
    "enduserLabel": null,
    "publisherGoalDescription": "kan meten met een meetlint van een meter",
    "domain": "Meten",
    "subDomain": "Meten - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA941",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-42",
    "publisherGoalLabel": "oppervlakte",
    "enduserLabel": null,
    "publisherGoalDescription": "kan oppervlaktes meten met een natuurlijke maat (bijv. met hokjes en tegels, afpassen met blaadjes)",
    "domain": "Meten",
    "subDomain": "Meten - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA942",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-43",
    "publisherGoalLabel": "tijd",
    "enduserLabel": null,
    "publisherGoalDescription": "kan halve uren aflezen op een analoge en digitale klok",
    "domain": "Meten",
    "subDomain": "Meten - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA943",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-44",
    "publisherGoalLabel": "tijd",
    "enduserLabel": null,
    "publisherGoalDescription": "weet wat een kalender is en hoe je die kan lezen",
    "domain": "Meten",
    "subDomain": "Meten - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA944",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-45",
    "publisherGoalLabel": "geld",
    "enduserLabel": null,
    "publisherGoalDescription": "kan gepast betalen met 1 en 2 euro munten en biljetten van 5 en 10 tot een bedrag van 20 euro",
    "domain": "Meten",
    "subDomain": "Meten - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA945",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-46",
    "publisherGoalLabel": "*oppervlakte",
    "enduserLabel": null,
    "publisherGoalDescription": "redeneren over oppervlakte (bijv. ‘dit tafelblad is langer dan dat tafelblad, maar ook smaller. op beide tafelbladen passen evenveel a4-tjes’)",
    "domain": "Meten",
    "subDomain": "Meten - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA946",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-47",
    "publisherGoalLabel": "*gewicht",
    "enduserLabel": null,
    "publisherGoalDescription": "experimenteren met het feit dat gewicht niet één op één samenvalt met omvang",
    "domain": "Meten",
    "subDomain": "Meten - 3b",
    "tags": [
      " zwaarder betekent niet altijd groter",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA947",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-48",
    "publisherGoalLabel": "*gewicht",
    "enduserLabel": null,
    "publisherGoalDescription": "oefenen met kilo's",
    "domain": "Meten",
    "subDomain": "Meten - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA948",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-49",
    "publisherGoalLabel": "*inhoud",
    "enduserLabel": null,
    "publisherGoalDescription": "oefenen met liters",
    "domain": "Meten",
    "subDomain": "Meten - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA950",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-51",
    "publisherGoalLabel": "oriënteren in de ruimte",
    "enduserLabel": null,
    "publisherGoalDescription": "kent de ruimtelijke begrippen links en rechts",
    "domain": "Meten",
    "subDomain": "Meetkunde - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA951",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-52",
    "publisherGoalLabel": "construeren",
    "enduserLabel": null,
    "publisherGoalDescription": "vouwwerk navouwen van een voorbeeld met een vouwreeks van enkele stappen",
    "domain": "Meten",
    "subDomain": "Meetkunde - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA952",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-53",
    "publisherGoalLabel": "opereren met vormen en figuren",
    "enduserLabel": null,
    "publisherGoalDescription": "kan bij afbeeldingen van eenvoudige ruimtelijke figuren de bijpassende uitslagen zoeken",
    "domain": "Meten",
    "subDomain": "Meetkunde - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA953",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-54",
    "publisherGoalLabel": "*oriënteren in de ruimte",
    "enduserLabel": null,
    "publisherGoalDescription": "maken van bouwplaten",
    "domain": "Meten",
    "subDomain": "Meetkunde - 3b",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA956",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-57",
    "publisherGoalLabel": "Komt ontspannen over",
    "enduserLabel": null,
    "publisherGoalDescription": "Komt ontspannen over",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA957",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-58",
    "publisherGoalLabel": "Heeft plezier in wat het doet",
    "enduserLabel": null,
    "publisherGoalDescription": "Heeft plezier in wat het doet",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA958",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-59",
    "publisherGoalLabel": "Laat zelfvertrouwen zien",
    "enduserLabel": null,
    "publisherGoalDescription": "Laat zelfvertrouwen zien",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA959",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-60",
    "publisherGoalLabel": "Durft zichzelf te zijn in de groep",
    "enduserLabel": null,
    "publisherGoalDescription": "Durft zichzelf te zijn in de groep",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Welbevinden",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA961",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-62",
    "publisherGoalLabel": "Toont belangstelling voor activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Toont belangstelling voor activiteiten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA962",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-63",
    "publisherGoalLabel": "Laat concentratie zien bij activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Laat concentratie zien bij activiteiten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA963",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-64",
    "publisherGoalLabel": "Kan opgaan in activiteiten",
    "enduserLabel": null,
    "publisherGoalDescription": "Kan opgaan in activiteiten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA964",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3b-doelen-65",
    "publisherGoalLabel": "Zet door bij activiteiten, ook als het tegenzit",
    "enduserLabel": null,
    "publisherGoalDescription": "Zet door bij activiteiten, ook als het tegenzit",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Betrokkenheid / taakgerichtheid",
    "tags": [
      "",
      "3b-doelen",
      "6-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA103",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-4",
    "publisherGoalLabel": "*luisteren",
    "enduserLabel": null,
    "publisherGoalDescription": "bespreken van een verhaallijn met wie, wat en waar-vragen",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA104",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-5",
    "publisherGoalLabel": "*luisteren",
    "enduserLabel": null,
    "publisherGoalDescription": "herkennen en gebruiken van een nieuw woord in een andere context",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA105",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-6",
    "publisherGoalLabel": "*luisteren",
    "enduserLabel": null,
    "publisherGoalDescription": "enigszins de inhoud van het verhaal voorspellen",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA106",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-7",
    "publisherGoalLabel": "*luisteren",
    "enduserLabel": null,
    "publisherGoalDescription": "vertellen over de opbouw in een verhaal en de situatie waarin het verhaal zich afspeelt",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA107",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-8",
    "publisherGoalLabel": "*spreken",
    "enduserLabel": null,
    "publisherGoalDescription": "vertellen van een persoonlijk verhaal",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA108",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-9",
    "publisherGoalLabel": "*spreken",
    "enduserLabel": null,
    "publisherGoalDescription": "vertellen en presenteren voor de groep",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA109",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-10",
    "publisherGoalLabel": "*spreken",
    "enduserLabel": null,
    "publisherGoalDescription": "variatie in woordgebruik, woordvorming en zinsvorming",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA1010",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-11",
    "publisherGoalLabel": "*gesprekken",
    "enduserLabel": null,
    "publisherGoalDescription": "in kleine en grote groepen actief deelnemen aan gesprekken, door te spreken en te luisteren",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA1011",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-12",
    "publisherGoalLabel": "*gesprekken",
    "enduserLabel": null,
    "publisherGoalDescription": "reflecteren op het verloop van het gesprek, de spreker en de boodschap",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA1012",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-13",
    "publisherGoalLabel": "*gesprekken",
    "enduserLabel": null,
    "publisherGoalDescription": "vertellen of het wel of niet eens is met een mening",
    "domain": "Mondelinge taal",
    "subDomain": "Mondelinge taal - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA1015",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-16",
    "publisherGoalLabel": "gevoelens",
    "enduserLabel": null,
    "publisherGoalDescription": "beschrijft welke gevoelens een situatie bij zichzelf kan oproepen",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Besef van zichzelf - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA1016",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-17",
    "publisherGoalLabel": "persoonskenmerken",
    "enduserLabel": null,
    "publisherGoalDescription": "zet vaardigheden en kwaliteiten van zichzelf in",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Besef van zichzelf - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA1018",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-19",
    "publisherGoalLabel": "gevoelens hanteren",
    "enduserLabel": null,
    "publisherGoalDescription": "kan achteraf vertellen waarom bepaald gedrag vertoond is",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Omgaan met zichzelf - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA1019",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-20",
    "publisherGoalLabel": "impulscontrole",
    "enduserLabel": null,
    "publisherGoalDescription": "kan eigen gedrag sturen in een lastige situatie",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Omgaan met zichzelf - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA1021",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-22",
    "publisherGoalLabel": "gevoelens",
    "enduserLabel": null,
    "publisherGoalDescription": "beschrijft welke gevoelens een situatie bij een ander kan oproepen",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Besef van de ander - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA1022",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-23",
    "publisherGoalLabel": "persoonskenmerken",
    "enduserLabel": null,
    "publisherGoalDescription": "benoemt kwaliteiten van de ander",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Besef van de ander - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA1024",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-25",
    "publisherGoalLabel": "aansluiten",
    "enduserLabel": null,
    "publisherGoalDescription": "kan omgaan met klasgenoten die niet hun voorkeur hebben",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Omgaan met de ander - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA1025",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-26",
    "publisherGoalLabel": "conflicten",
    "enduserLabel": null,
    "publisherGoalDescription": "bedenkt tijdens het conflict oplossingen",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Omgaan met de ander - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA1026",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-27",
    "publisherGoalLabel": "samenwerken",
    "enduserLabel": null,
    "publisherGoalDescription": "kan hulp vragen en bieden tijdens gezamenlijke activiteiten",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Omgaan met de ander - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA1028",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-29",
    "publisherGoalLabel": "weloverwogen kiezen",
    "enduserLabel": null,
    "publisherGoalDescription": "legt uit welke gevolgen een keuze heeft",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Keuzes maken - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  },
  {
    "id": "GA1029",
    "schemaVersion": "1.0.0",
    "publisherName": "Gouwe Academie",
    "publisherGoalId": "3-doelen-30",
    "publisherGoalLabel": "zelfstandigheid",
    "enduserLabel": null,
    "publisherGoalDescription": "maakt complexere taken af",
    "domain": "Sociaal-emotioneel",
    "subDomain": "Keuzes maken - 3",
    "tags": [
      "",
      "3-doelen",
      "1-10"
    ],
    "maxValue": 1
  }
]

